//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;
  
    constructor(
      baseUrl?: string,
      http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
    ) {
      this.http = http ? http : (window as any);
      this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarrierAddresses(
      carrierId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AddressSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriers/{carrierId}/address";
      if (carrierId === undefined || carrierId === null)
        throw new Error("The parameter 'carrierId' must be defined.");
      url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarrierAddresses(_response);
      });
    }
  
    protected processGetAllCarrierAddresses(
      response: Response
    ): Promise<AddressSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AddressSearchResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createCarrierAddress(
      v: string,
      carrierId: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateAddressModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriers/{carrierId}/address";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (carrierId === undefined || carrierId === null)
        throw new Error("The parameter 'carrierId' must be defined.");
      url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateCarrierAddress(_response);
      });
    }
  
    protected processCreateCarrierAddress(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateCarrierAddress(
      v: string,
      carrierId: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateAddressModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriers/{carrierId}/address";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (carrierId === undefined || carrierId === null)
        throw new Error("The parameter 'carrierId' must be defined.");
      url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateCarrierAddress(_response);
      });
    }
  
    protected processUpdateCarrierAddress(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarrierAddressById(
      id: number,
      v: string,
      carrierId: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AddressModel> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriers/{carrierId}/address/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (carrierId === undefined || carrierId === null)
        throw new Error("The parameter 'carrierId' must be defined.");
      url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierAddressById(_response);
      });
    }
  
    protected processGetCarrierAddressById(
      response: Response
    ): Promise<AddressModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AddressModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteCarrierAddress(
      id: number,
      v: string,
      carrierId: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriers/{carrierId}/address/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (carrierId === undefined || carrierId === null)
        throw new Error("The parameter 'carrierId' must be defined.");
      url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteCarrierAddress(_response);
      });
    }
  
    protected processDeleteCarrierAddress(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAddressTypeLookupForCarrier(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriers/addressTypeLookupForCarrier";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAddressTypeLookupForCarrier(_response);
      });
    }
  
    protected processGetAddressTypeLookupForCarrier(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param agentId (optional)
     * @param companyId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAppointments(
      v: string,
      agentId?: number | undefined,
      companyId?: number | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AppointmentResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/appointments?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (agentId === null)
        throw new Error("The parameter 'agentId' cannot be null.");
      else if (agentId !== undefined)
        url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (companyId === null)
        throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllAppointments(_response);
      });
    }
  
    protected processGetAllAppointments(
      response: Response
    ): Promise<AppointmentResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AppointmentResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<AppointmentResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createAppointment(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateAppointmentModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/appointments";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateAppointment(_response);
      });
    }
  
    protected processCreateAppointment(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateAppointment(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateAppointmentModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/appointments";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateAppointment(_response);
      });
    }
  
    protected processUpdateAppointment(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAppointmentById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AppointmentDetailModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/appointments/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAppointmentById(_response);
      });
    }
  
    protected processGetAppointmentById(
      response: Response
    ): Promise<AppointmentDetailModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AppointmentDetailModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteAppointment(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/appointments/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteAppointment(_response);
      });
    }
  
    protected processDeleteAppointment(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getStates(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<StatesResponse[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/appointments/states";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetStates(_response);
      });
    }
  
    protected processGetStates(response: Response): Promise<StatesResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as StatesResponse[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<StatesResponse[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCompaniesByContractId(
      contractId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CompanyResponse[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/appointments/companies/{contractId}";
      if (contractId === undefined || contractId === null)
        throw new Error("The parameter 'contractId' must be defined.");
      url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCompaniesByContractId(_response);
      });
    }
  
    protected processGetCompaniesByContractId(
      response: Response
    ): Promise<CompanyResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CompanyResponse[]);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLastBulkMailShippingNumber(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<BulkMailShippingResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/BulkMailShippingConfiguration";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLastBulkMailShippingNumber(_response);
      });
    }
  
    protected processGetLastBulkMailShippingNumber(
      response: Response
    ): Promise<BulkMailShippingResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as BulkMailShippingResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<BulkMailShippingResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    updateBulkMailShippingNumber(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/BulkMailShippingConfiguration";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateBulkMailShippingNumber(_response);
      });
    }
  
    protected processUpdateBulkMailShippingNumber(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getDocumentBlobPath(
      documentid: string | null,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<string> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/BulkMailShippingConfiguration/getdocumentblobpath/{documentid}";
      if (documentid === undefined || documentid === null)
        throw new Error("The parameter 'documentid' must be defined.");
      url_ = url_.replace("{documentid}", encodeURIComponent("" + documentid));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetDocumentBlobPath(_response);
      });
    }
  
    protected processGetDocumentBlobPath(response: Response): Promise<string> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<string>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentPolicyScreenLookups(
      agentId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<GetAgentPolicyScreenLookupsResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/carriers/agentpolicyscreenlookups/{agentId}";
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAgentPolicyScreenLookups(_response);
      });
    }
  
    protected processGetAgentPolicyScreenLookups(
      response: Response
    ): Promise<GetAgentPolicyScreenLookupsResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetAgentPolicyScreenLookupsResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAppointmentCarriersByAgent(
      v: string,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CarriersByAgentResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriers/appointmentcarriersbyagent?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAppointmentCarriersByAgent(_response);
      });
    }
  
    protected processGetAppointmentCarriersByAgent(
      response: Response
    ): Promise<CarriersByAgentResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CarriersByAgentResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CarriersByAgentResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarriersByCarrierGroupLookup(
      carriergroupid: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/carriers/carriersbycarriergroup/{carriergroupid}";
      if (carriergroupid === undefined || carriergroupid === null)
        throw new Error("The parameter 'carriergroupid' must be defined.");
      url_ = url_.replace(
        "{carriergroupid}",
        encodeURIComponent("" + carriergroupid)
      );
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarriersByCarrierGroupLookup(_response);
      });
    }
  
    protected processGetCarriersByCarrierGroupLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarrierLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriers/lookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarrierLookup(_response);
      });
    }
  
    protected processGetAllCarrierLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllSupplyCarrierLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CarrierSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriers/supplycarrierlookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllSupplyCarrierLookup(_response);
      });
    }
  
    protected processGetAllSupplyCarrierLookup(
      response: Response
    ): Promise<CarrierSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CarrierSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CarrierSearchResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarrierDivisionLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriers/divisionlookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierDivisionLookup(_response);
      });
    }
  
    protected processGetCarrierDivisionLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMasterCarrierLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriers/masterCarrierLookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllMasterCarrierLookup(_response);
      });
    }
  
    protected processGetAllMasterCarrierLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMasterCarrierById(
      masterCarrierId: string,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<MasterCarrierModel> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/carriers/masterCarrierById/{masterCarrierId}";
      if (masterCarrierId === undefined || masterCarrierId === null)
        throw new Error("The parameter 'masterCarrierId' must be defined.");
      url_ = url_.replace(
        "{masterCarrierId}",
        encodeURIComponent("" + masterCarrierId)
      );
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetMasterCarrierById(_response);
      });
    }
  
    protected processGetMasterCarrierById(
      response: Response
    ): Promise<MasterCarrierModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as MasterCarrierModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMasterCarrierGroupLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<MasterCarrierGroupModel[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriers/masterCarrierGroupLookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllMasterCarrierGroupLookup(_response);
      });
    }
  
    protected processGetAllMasterCarrierGroupLookup(
      response: Response
    ): Promise<MasterCarrierGroupModel[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as MasterCarrierGroupModel[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<MasterCarrierGroupModel[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getActiveInactiveAllCarrierLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/carriers/getactiveinactiveallcarrierlookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetActiveInactiveAllCarrierLookup(_response);
      });
    }
  
    protected processGetActiveInactiveAllCarrierLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarrierGroupLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriergroups/lookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarrierGroupLookup(_response);
      });
    }
  
    protected processGetAllCarrierGroupLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarrierGroupByCompanyId(
      companyGroupId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CarrierGroupModel> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/carriergroups/getnonhiddencompanybygroup/{companyGroupId}";
      if (companyGroupId === undefined || companyGroupId === null)
        throw new Error("The parameter 'companyGroupId' must be defined.");
      url_ = url_.replace(
        "{companyGroupId}",
        encodeURIComponent("" + companyGroupId)
      );
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierGroupByCompanyId(_response);
      });
    }
  
    protected processGetCarrierGroupByCompanyId(
      response: Response
    ): Promise<CarrierGroupModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CarrierGroupModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMasterCarrierGroupQuery(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MasterCarrierGroupResponse[]> {
        let url_ = this.baseUrl + "/api/contract/v{v}/carriergroups/mastercarriergroups";
        if (v === undefined || v === null)
            throw new globalThis.Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMasterCarrierGroupQuery(_response);
        });
    }

    protected processGetMasterCarrierGroupQuery(response: Response): Promise<MasterCarrierGroupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MasterCarrierGroupResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MasterCarrierGroupResponse[]>(null as any);
    }

    /**
     * @param isHidden (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarriersGroups(
      v: string,
      isHidden?: boolean | null | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CarrierGroupsSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriermanagement?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (isHidden !== undefined && isHidden !== null)
        url_ += "IsHidden=" + encodeURIComponent("" + isHidden) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarriersGroups(_response);
      });
    }
  
    protected processGetAllCarriersGroups(
      response: Response
    ): Promise<CarrierGroupsSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CarrierGroupsSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CarrierGroupsSearchResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addCarriersGroup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CarrierGroupModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriermanagement";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddCarriersGroup(_response);
      });
    }
  
    protected processAddCarriersGroup(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateCarriersGroup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CarrierGroupModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriermanagement";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateCarriersGroup(_response);
      });
    }
  
    protected processUpdateCarriersGroup(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarriersGroupById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CarrierGroupModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriermanagement/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarriersGroupById(_response);
      });
    }
  
    protected processGetCarriersGroupById(
      response: Response
    ): Promise<CarrierGroupModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CarrierGroupModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param searchText (optional)
     * @param status (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarrierGroupsAsExcel(
      v: string,
      searchText?: string | null | undefined,
      status?: boolean | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ReportFile> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriermanagement/downloadcarriergroups?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (searchText !== undefined && searchText !== null)
        url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
      if (status !== undefined && status !== null)
        url_ += "Status=" + encodeURIComponent("" + status) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierGroupsAsExcel(_response);
      });
    }
  
    protected processGetCarrierGroupsAsExcel(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param isHidden (optional)
     * @param carrierGroupId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarrierssAsExcel(
      v: string,
      isHidden?: boolean | null | undefined,
      carrierGroupId?: number[] | null | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ReportFile> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriermanagement/downloadcarriers?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (isHidden !== undefined && isHidden !== null)
        url_ += "IsHidden=" + encodeURIComponent("" + isHidden) + "&";
      if (carrierGroupId !== undefined && carrierGroupId !== null)
        carrierGroupId &&
          carrierGroupId.forEach((item) => {
            url_ += "CarrierGroupId=" + encodeURIComponent("" + item) + "&";
          });
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierssAsExcel(_response);
      });
    }
  
    protected processGetCarrierssAsExcel(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param isHidden (optional)
     * @param carrierGroupId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarrierss(
      v: string,
      isHidden?: boolean | null | undefined,
      carrierGroupId?: number[] | null | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AllCarriersResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/carriermanagement/getallcarriers?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (isHidden !== undefined && isHidden !== null)
        url_ += "IsHidden=" + encodeURIComponent("" + isHidden) + "&";
      if (carrierGroupId !== undefined && carrierGroupId !== null)
        carrierGroupId &&
          carrierGroupId.forEach((item) => {
            url_ += "CarrierGroupId=" + encodeURIComponent("" + item) + "&";
          });
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarrierss(_response);
      });
    }
  
    protected processGetAllCarrierss(
      response: Response
    ): Promise<AllCarriersResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AllCarriersResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<AllCarriersResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarriersById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CarrierByIdModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriermanagement/carrier/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarriersById(_response);
      });
    }
  
    protected processGetCarriersById(
      response: Response
    ): Promise<CarrierByIdModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CarrierByIdModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addCarriers(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateCarrierModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriermanagement/addcarrier";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddCarriers(_response);
      });
    }
  
    protected processAddCarriers(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateCarriers(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateCarrierModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriermanagement/updatecarrier";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateCarriers(_response);
      });
    }
  
    protected processUpdateCarriers(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param companyId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarrierNotes(
      v: string,
      companyId?: number | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<NotesSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriernotes?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
        throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarrierNotes(_response);
      });
    }
  
    protected processGetAllCarrierNotes(
      response: Response
    ): Promise<NotesSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as NotesSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<NotesSearchResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addCarrierNote(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateNoteModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriernotes";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddCarrierNote(_response);
      });
    }
  
    protected processAddCarrierNote(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateCarrierNote(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateNoteModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriernotes";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateCarrierNote(_response);
      });
    }
  
    protected processUpdateCarrierNote(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarrierNoteById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<NoteModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriernotes/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierNoteById(_response);
      });
    }
  
    protected processGetCarrierNoteById(response: Response): Promise<NoteModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as NoteModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteCarrierNote(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/carriernotes/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteCarrierNote(_response);
      });
    }
  
    protected processDeleteCarrierNote(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param year (optional)
     * @param companyId (optional)
     * @param agentId (optional)
     * @param serachText (optional)
     * @param isIncludeInactiveCarrier (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCertifications(
      v: string,
      year?: number | undefined,
      companyId?: number | undefined,
      agentId?: number | undefined,
      serachText?: string | null | undefined,
      isIncludeInactiveCarrier?: boolean | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CertificationsSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/certification?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (year === null) throw new Error("The parameter 'year' cannot be null.");
      else if (year !== undefined)
        url_ += "Year=" + encodeURIComponent("" + year) + "&";
      if (companyId === null)
        throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (agentId === null)
        throw new Error("The parameter 'agentId' cannot be null.");
      else if (agentId !== undefined)
        url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (serachText !== undefined && serachText !== null)
        url_ += "SerachText=" + encodeURIComponent("" + serachText) + "&";
      if (isIncludeInactiveCarrier === null)
        throw new Error(
          "The parameter 'isIncludeInactiveCarrier' cannot be null."
        );
      else if (isIncludeInactiveCarrier !== undefined)
        url_ +=
          "IsIncludeInactiveCarrier=" +
          encodeURIComponent("" + isIncludeInactiveCarrier) +
          "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCertifications(_response);
      });
    }
  
    protected processGetAllCertifications(
      response: Response
    ): Promise<CertificationsSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CertificationsSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CertificationsSearchResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addCertification(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CertificationModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/certification";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddCertification(_response);
      });
    }
  
    protected processAddCertification(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateCertification(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CertificationModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/certification";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateCertification(_response);
      });
    }
  
    protected processUpdateCertification(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    certificationsDropDownValues(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CertificationsDropDownValuesResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/certification/CertificationsDropDownValues";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCertificationsDropDownValues(_response);
      });
    }
  
    protected processCertificationsDropDownValues(
      response: Response
    ): Promise<CertificationsDropDownValuesResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CertificationsDropDownValuesResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CertificationsDropDownValuesResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCertificationById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CertificationModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/certification/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCertificationById(_response);
      });
    }
  
    protected processGetCertificationById(
      response: Response
    ): Promise<CertificationModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CertificationModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteCertification(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/certification/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteCertification(_response);
      });
    }
  
    protected processDeleteCertification(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param year (optional)
     * @param companyId (optional)
     * @param agentId (optional)
     * @param serachText (optional)
     * @param isIncludeInactiveCarrier (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCertificationsByAgent(
      v: string,
      year?: number | undefined,
      companyId?: number | undefined,
      agentId?: number | undefined,
      serachText?: string | null | undefined,
      isIncludeInactiveCarrier?: boolean | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CertificationsSearchByAgentResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/certification/getallcertificationsbyagent?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (year === null) throw new Error("The parameter 'year' cannot be null.");
      else if (year !== undefined)
        url_ += "Year=" + encodeURIComponent("" + year) + "&";
      if (companyId === null)
        throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (agentId === null)
        throw new Error("The parameter 'agentId' cannot be null.");
      else if (agentId !== undefined)
        url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (serachText !== undefined && serachText !== null)
        url_ += "SerachText=" + encodeURIComponent("" + serachText) + "&";
      if (isIncludeInactiveCarrier === null)
        throw new Error(
          "The parameter 'isIncludeInactiveCarrier' cannot be null."
        );
      else if (isIncludeInactiveCarrier !== undefined)
        url_ +=
          "IsIncludeInactiveCarrier=" +
          encodeURIComponent("" + isIncludeInactiveCarrier) +
          "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCertificationsByAgent(_response);
      });
    }
  
    protected processGetAllCertificationsByAgent(
      response: Response
    ): Promise<CertificationsSearchByAgentResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CertificationsSearchByAgentResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CertificationsSearchByAgentResponse>(null as any);
    }
  
    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCommunication(
      contractid: number,
      v: string,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CommunicationResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/communications/{contractid}?";
      if (contractid === undefined || contractid === null)
        throw new Error("The parameter 'contractid' must be defined.");
      url_ = url_.replace("{contractid}", encodeURIComponent("" + contractid));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCommunication(_response);
      });
    }
  
    protected processGetAllCommunication(
      response: Response
    ): Promise<CommunicationResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CommunicationResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CommunicationResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createCommunication(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CommunicationRequest | undefined
    ): Promise<LicenseCommunication[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/communications";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateCommunication(_response);
      });
    }
  
    protected processCreateCommunication(
      response: Response
    ): Promise<LicenseCommunication[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicenseCommunication[]);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LicenseCommunication[]>(null as any);
    }
  
    /**
     * @param contractId (optional)
     * @param communicationId (optional)
     * @param removeFromHierarchyPockets (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteCommunication(
      v: string,
      contractId?: number | null | undefined,
      communicationId?: number | undefined,
      removeFromHierarchyPockets?: boolean | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/communications?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (contractId !== undefined && contractId !== null)
        url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
      if (communicationId === null)
        throw new Error("The parameter 'communicationId' cannot be null.");
      else if (communicationId !== undefined)
        url_ +=
          "CommunicationId=" + encodeURIComponent("" + communicationId) + "&";
      if (removeFromHierarchyPockets === null)
        throw new Error(
          "The parameter 'removeFromHierarchyPockets' cannot be null."
        );
      else if (removeFromHierarchyPockets !== undefined)
        url_ +=
          "RemoveFromHierarchyPockets=" +
          encodeURIComponent("" + removeFromHierarchyPockets) +
          "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteCommunication(_response);
      });
    }
  
    protected processDeleteCommunication(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommunicationLookup(
      contractId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CommunicationLookupResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/communications/{contractId}/lookup";
      if (contractId === undefined || contractId === null)
        throw new Error("The parameter 'contractId' must be defined.");
      url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCommunicationLookup(_response);
      });
    }
  
    protected processGetCommunicationLookup(
      response: Response
    ): Promise<CommunicationLookupResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CommunicationLookupResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param companyId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCompanyLicenseNumberDefaults(
      v: string,
      companyId?: number | null | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CompanyLicenseNumberDefaultsSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/companylicensenumberdefault?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId !== undefined && companyId !== null)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCompanyLicenseNumberDefaults(_response);
      });
    }
  
    protected processGetAllCompanyLicenseNumberDefaults(
      response: Response
    ): Promise<CompanyLicenseNumberDefaultsSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CompanyLicenseNumberDefaultsSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<CompanyLicenseNumberDefaultsSearchResponse>(
        null as any
      );
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createCompanyLicenseNumberDefault(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CompanyLicenseNumberDefaultModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/companylicensenumberdefault";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateCompanyLicenseNumberDefault(_response);
      });
    }
  
    protected processCreateCompanyLicenseNumberDefault(
      response: Response
    ): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateCompanyLicenseNumberDefault(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CompanyLicenseNumberDefaultModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/companylicensenumberdefault";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateCompanyLicenseNumberDefault(_response);
      });
    }
  
    protected processUpdateCompanyLicenseNumberDefault(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCompanyLicenseNumberDefaultsLookup(
      companyId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/companylicensenumberdefault/companylicensenumberdefaultslookup/{companyId}";
      if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
      url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCompanyLicenseNumberDefaultsLookup(_response);
      });
    }
  
    protected processGetAllCompanyLicenseNumberDefaultsLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCompanyLicenseNumberDefaultById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<CompanyLicenseNumberDefaultModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/companylicensenumberdefault/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCompanyLicenseNumberDefaultById(_response);
      });
    }
  
    protected processGetCompanyLicenseNumberDefaultById(
      response: Response
    ): Promise<CompanyLicenseNumberDefaultModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CompanyLicenseNumberDefaultModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteCompanyLicenseNumberDefault(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/companylicensenumberdefault/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteCompanyLicenseNumberDefault(_response);
      });
    }
  
    protected processDeleteCompanyLicenseNumberDefault(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarriersLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/companylicensenumberdefault/carrierlookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarriersLookup(_response);
      });
    }
  
    protected processGetAllCarriersLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLicenseNumbersLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/companylicensenumberdefault/licenseNumberTypelookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLicenseNumbersLookup(_response);
      });
    }
  
    protected processGetAllLicenseNumbersLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param carrierId (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarrierContact(
      v: string,
      carrierId?: number | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AllContactResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (carrierId === null)
        throw new Error("The parameter 'carrierId' cannot be null.");
      else if (carrierId !== undefined)
        url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllCarrierContact(_response);
      });
    }
  
    protected processGetAllCarrierContact(
      response: Response
    ): Promise<AllContactResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AllContactResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createCarrierContact(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateContactModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateCarrierContact(_response);
      });
    }
  
    protected processCreateCarrierContact(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateCarrierContact(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateContactModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateCarrierContact(_response);
      });
    }
  
    protected processUpdateCarrierContact(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarrierContactById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ContactByIdResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierContactById(_response);
      });
    }
  
    protected processGetCarrierContactById(
      response: Response
    ): Promise<ContactByIdResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContactByIdResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteCarrierContact(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteCarrierContact(_response);
      });
    }
  
    protected processDeleteCarrierContact(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContactLookups(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ContactLookupsModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts/contactlookups";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContactLookups(_response);
      });
    }
  
    protected processGetContactLookups(
      response: Response
    ): Promise<ContactLookupsModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContactLookupsModel);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ContactLookupsModel>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getEmailTypes(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts/emailtypes";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetEmailTypes(_response);
      });
    }
  
    protected processGetEmailTypes(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAlternativePOCTypes(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contacts/alternativePOCtypes";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAlternativePOCTypes(_response);
      });
    }
  
    protected processGetAlternativePOCTypes(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getAllContract(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractRequest | undefined
    ): Promise<ContractResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/getAll";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllContract(_response);
      });
    }
  
    protected processGetAllContract(
      response: Response
    ): Promise<ContractResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContractResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ContractResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractById(
      id: number,
      agentId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      integrityMasterCarrierId?: number | undefined,
      writingNumber?: string | undefined,
      startDate?: string | undefined,
      productSubCategory?: string | undefined,
      contractStatus?: string | undefined
    ): Promise<ContractModel> {
        let url_ = this.baseUrl + "/api/contract/v{v}/contracts/{id}/{agentId}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (integrityMasterCarrierId !== null && integrityMasterCarrierId !== undefined)
        url_ += (url_.indexOf("?") === -1 ? "?" : "&") + "integrityMasterCarrierId=" + encodeURIComponent("" + integrityMasterCarrierId);
      if (writingNumber !== null && writingNumber !== undefined)
        url_ += (url_.indexOf("?") === -1 ? "?" : "&") + "writingNumber=" + encodeURIComponent("" + writingNumber);
      if (startDate !== null && startDate !== undefined)
        url_ += (url_.indexOf("?") === -1 ? "?" : "&") + "startDate=" + encodeURIComponent("" + startDate);
      if (productSubCategory !== null && productSubCategory !== undefined)
        url_ += (url_.indexOf("?") === -1 ? "?" : "&") + "productSubCategory=" + encodeURIComponent("" + productSubCategory);
      if (contractStatus !== null && contractStatus !== undefined)
        url_ += (url_.indexOf("?") === -1 ? "?" : "&") + "contractStatus=" + encodeURIComponent("" + contractStatus);
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractById(_response);
      });
    }
  
    protected processGetContractById(response: Response): Promise<ContractModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContractModel);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ContractModel>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractDetailsById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ContractViewModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractDetailsById(_response);
      });
    }
  
    protected processGetContractDetailsById(
      response: Response
    ): Promise<ContractViewModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContractViewModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteContract(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<DeleteResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteContract(_response);
      });
    }
  
    protected processDeleteContract(response: Response): Promise<DeleteResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as DeleteResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Bad Request",
            status,
            _responseText,
            _headers,
            result400
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createContract(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateContractModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateContract(_response);
      });
    }
  
    protected processCreateContract(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateContract(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateContractModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateContract(_response);
      });
    }
  
    protected processUpdateContract(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param contractId (optional)
     * @param downLineAffected (optional)
     * @param statusReasonId (optional)
     * @param endDate (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    replaceContract(
      v: string,
      contractId?: number | undefined,
      downLineAffected?: boolean | undefined,
      statusReasonId?: number | undefined,
      endDate?: Date | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/replace?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (contractId === null)
        throw new Error("The parameter 'contractId' cannot be null.");
      else if (contractId !== undefined)
        url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
      if (downLineAffected === null)
        throw new Error("The parameter 'downLineAffected' cannot be null.");
      else if (downLineAffected !== undefined)
        url_ +=
          "downLineAffected=" + encodeURIComponent("" + downLineAffected) + "&";
      if (statusReasonId === null)
        throw new Error("The parameter 'statusReasonId' cannot be null.");
      else if (statusReasonId !== undefined)
        url_ += "statusReasonId=" + encodeURIComponent("" + statusReasonId) + "&";
      if (endDate === null)
        throw new Error("The parameter 'endDate' cannot be null.");
      else if (endDate !== undefined)
        url_ +=
          "endDate=" +
          encodeURIComponent(endDate ? "" + endDate.toISOString() : "") +
          "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processReplaceContract(_response);
      });
    }
  
    protected processReplaceContract(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param contractId (optional)
     * @param immediateUplineId (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    updateImmediateUpline(
      v: string,
      contractId?: number | undefined,
      immediateUplineId?: number | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/updateimmediateupline?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (contractId === null)
        throw new Error("The parameter 'contractId' cannot be null.");
      else if (contractId !== undefined)
        url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
      if (immediateUplineId === null)
        throw new Error("The parameter 'immediateUplineId' cannot be null.");
      else if (immediateUplineId !== undefined)
        url_ +=
          "ImmediateUplineId=" + encodeURIComponent("" + immediateUplineId) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateImmediateUpline(_response);
      });
    }
  
    protected processUpdateImmediateUpline(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractOptions(
      agentId: number,
      companyId: number,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ContactOptionsResponse> {
      let url_ = this.baseUrl + "/contactoptions?";
      if (agentId === undefined || agentId === null)
        throw new Error(
          "The parameter 'agentId' must be defined and cannot be null."
        );
      else url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (companyId === undefined || companyId === null)
        throw new Error(
          "The parameter 'companyId' must be defined and cannot be null."
        );
      else url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractOptions(_response);
      });
    }
  
    protected processGetContractOptions(
      response: Response
    ): Promise<ContactOptionsResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContactOptionsResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ContactOptionsResponse>(null as any);
    }
  
    /**
     * @param contractId (optional)
     * @param viewScreen (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractNotes(
      agentId: number,
      companyId: number,
      contractId?: number | undefined,
      viewScreen?: boolean | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<Notes[]> {
      let url_ = this.baseUrl + "/contractnotes?";
      if (agentId === undefined || agentId === null)
        throw new Error(
          "The parameter 'agentId' must be defined and cannot be null."
        );
      else url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (companyId === undefined || companyId === null)
        throw new Error(
          "The parameter 'companyId' must be defined and cannot be null."
        );
      else url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (contractId === null)
        throw new Error("The parameter 'contractId' cannot be null.");
      else if (contractId !== undefined)
        url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
      if (viewScreen === null)
        throw new Error("The parameter 'viewScreen' cannot be null.");
      else if (viewScreen !== undefined)
        url_ += "ViewScreen=" + encodeURIComponent("" + viewScreen) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractNotes(_response);
      });
    }
  
    protected processGetContractNotes(response: Response): Promise<Notes[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as Notes[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<Notes[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    hasContractForAgent(
      agentId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<boolean> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/agents/{agentId}/hascontract";
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processHasContractForAgent(_response);
      });
    }
  
    protected processHasContractForAgent(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<boolean>(null as any);
    }
  
    /**
     * @param statusId (optional)
     * @param option (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getStatusReason(
      v: string,
      statusId?: number | undefined,
      option?: boolean | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<StatusReasonResponse[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/statusreason?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (statusId === null)
        throw new Error("The parameter 'statusId' cannot be null.");
      else if (statusId !== undefined)
        url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
      if (option === null)
        throw new Error("The parameter 'option' cannot be null.");
      else if (option !== undefined)
        url_ += "option=" + encodeURIComponent("" + option) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetStatusReason(_response);
      });
    }
  
    protected processGetStatusReason(
      response: Response
    ): Promise<StatusReasonResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as StatusReasonResponse[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<StatusReasonResponse[]>(null as any);
    }
  
    /**
     * @param companyId (optional)
     * @param isContractStatus (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getImmediateUpline(
      contractId: number,
      agentId: number,
      v: string,
      companyId?: number | undefined,
      isContractStatus?: boolean | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ImmediateUplineResponse[]> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/contracts/immediateupline/{contractId}/{agentId}?";
      if (contractId === undefined || contractId === null)
        throw new Error("The parameter 'contractId' must be defined.");
      url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
        throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (isContractStatus === null)
        throw new Error("The parameter 'isContractStatus' cannot be null.");
      else if (isContractStatus !== undefined)
        url_ +=
          "IsContractStatus=" + encodeURIComponent("" + isContractStatus) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetImmediateUpline(_response);
      });
    }
  
    protected processGetImmediateUpline(
      response: Response
    ): Promise<ImmediateUplineResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ImmediateUplineResponse[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ImmediateUplineResponse[]>(null as any);
  }
  

  /**
     * @param companyId (optional)
     * @param isContractStatus (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getImmediateActiveUpline(
      contractId: number,
      agentId: number,
      v: string,
      companyId?: number | undefined,
      isContractStatus?: boolean | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ImmediateUplineResponse[]> {
      let url_ =
        this.baseUrl +
        "/api/contracting/v{v}/contractsManagement/immediateupline/{contractId}/{agentId}?";
      if (contractId === undefined || contractId === null)
        throw new Error("The parameter 'contractId' must be defined.");
      url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
        throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (isContractStatus === null)
        throw new Error("The parameter 'isContractStatus' cannot be null.");
      else if (isContractStatus !== undefined)
        url_ +=
          "IsContractStatus=" + encodeURIComponent("" + isContractStatus) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetImmediateActiveUpline(_response);
      });
    }
  
    protected processGetImmediateActiveUpline(
      response: Response
    ): Promise<ImmediateUplineResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ImmediateUplineResponse[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ImmediateUplineResponse[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getWritingNumberTypes(
      contractId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<WritingNumberTypeResponse[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/writingnumbertypes/{contractId}";
      if (contractId === undefined || contractId === null)
        throw new Error("The parameter 'contractId' must be defined.");
      url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetWritingNumberTypes(_response);
      });
    }
  
    protected processGetWritingNumberTypes(
      response: Response
    ): Promise<WritingNumberTypeResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as WritingNumberTypeResponse[]);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getReportContractStatusLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/reportcontractstatuslookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetReportContractStatusLookup(_response);
      });
    }
  
    protected processGetReportContractStatusLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractAssocaitionsById(
      contractId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ContractAssocaitionsResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/contracts/contractassocaitionsbyid/{contractId}";
      if (contractId === undefined || contractId === null)
        throw new Error("The parameter 'contractId' must be defined.");
      url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractAssocaitionsById(_response);
      });
    }
  
    protected processGetContractAssocaitionsById(
      response: Response
    ): Promise<ContractAssocaitionsResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContractAssocaitionsResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    downloadContract(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/downloadcontract";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDownloadContract(_response);
      });
    }
  
    protected processDownloadContract(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductDetailsLookup(
      companyId: number,
      agentId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ProductDetailsLookupResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/contracts/productdetailslookup/{companyId}/{agentId}";
      if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
      url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetProductDetailsLookup(_response);
      });
    }
  
    protected processGetProductDetailsLookup(
      response: Response
    ): Promise<ProductDetailsLookupResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProductDetailsLookupResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ProductDetailsLookupResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractUplineDetail(
      companyId: number,
      agentId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ContractUplineDetailResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/contracts/contractuplinedetail/{companyId}/{agentId}";
      if (companyId === undefined || companyId === null)
        throw new Error("The parameter 'companyId' must be defined.");
      url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractUplineDetail(_response);
      });
    }
  
    protected processGetContractUplineDetail(
      response: Response
    ): Promise<ContractUplineDetailResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContractUplineDetailResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ContractUplineDetailResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateContractGridColumnOrder(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractGridColumnRequest | undefined
    ): Promise<void> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/updateontractgridcolumnorder";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateContractGridColumnOrder(_response);
      });
    }
  
    protected processUpdateContractGridColumnOrder(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractGridColumnOrder(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<string> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/getcontractgridcolumnorder";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractGridColumnOrder(_response);
      });
    }
  
    protected processGetContractGridColumnOrder(
      response: Response
    ): Promise<string> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<string>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional)
     * @return Success
     */
    bulkUpdateContracts(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      file?: FileParameter | null | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/BulkUpdateContracts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = new FormData();
      if (file !== null && file !== undefined)
        content_.append(
          "File",
          file.data,
          file.fileName ? file.fileName : "File"
        );
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processBulkUpdateContracts(_response);
      });
    }
  
    protected processBulkUpdateContracts(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    bulkUpdateContractsTemplate(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<DownloadFileModel> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/BulkUpdateContractsTemplate";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processBulkUpdateContractsTemplate(_response);
      });
    }
  
    protected processBulkUpdateContractsTemplate(
      response: Response
    ): Promise<DownloadFileModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as DownloadFileModel);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<DownloadFileModel>(null as any);
    }
  
    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    bulkUpdateContractsQueue(
      v: string,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<BulkUpdateContractsQueueResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/BulkUpdateContractsQueue?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processBulkUpdateContractsQueue(_response);
      });
    }
  
    protected processBulkUpdateContractsQueue(
      response: Response
    ): Promise<BulkUpdateContractsQueueResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as BulkUpdateContractsQueueResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<BulkUpdateContractsQueueResponse>(null as any);
    }
  
    /**
     * @param batchId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    bulkUpdateContractsHistory(
      v: string,
      batchId?: number | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<BulkUpdateContractsHistoryResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contracts/BulkUpdateContractsHistory?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processBulkUpdateContractsHistory(_response);
      });
    }
  
    protected processBulkUpdateContractsHistory(
      response: Response
    ): Promise<BulkUpdateContractsHistoryResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as BulkUpdateContractsHistoryResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<BulkUpdateContractsHistoryResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateRTSContracts(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: RTSUpdateContractRequestModel | undefined
    ): Promise<boolean> {
      let url_ = this.baseUrl + "/api/contract/v{v}/contracts/updatertscontracts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateRTSContracts(_response);
      });
    }
  
    protected processUpdateRTSContracts(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<boolean>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getAllContracts(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: GetContractManagementRequest | undefined
    ): Promise<ContractManagementResponse> {
      let url_ =
        this.baseUrl + "/api/contracting/v{v}/contractsManagement/GetAllContracts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllContracts(_response);
      });
    }
  
    protected processGetAllContracts(
      response: Response
    ): Promise<ContractManagementResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ContractManagementResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ContractManagementResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMetrics(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<GetContractManagementResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contractsManagement/GetAllMetrics";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllMetrics(_response);
      });
    }
  
    protected processGetAllMetrics(
      response: Response
    ): Promise<GetContractManagementResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContractManagementResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<GetContractManagementResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    sendContractRequest(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: SendContractInviteRequest | undefined
    ): Promise<boolean> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contractsManagement/SendContractRequest";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processSendContractRequest(_response);
      });
    }
  
    protected processSendContractRequest(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<boolean>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getContractRequest(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: SendContractInviteRequest | undefined
    ): Promise<number> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contractsManagement/GetContractRequest";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractRequest(_response);
      });
    }
  
    protected processGetContractRequest(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateSubmissionLicense(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: SubmissionLicenseRequest | undefined
    ): Promise<boolean> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/contractsManagement/UpdateSubmissionLicense";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateSubmissionLicense(_response);
      });
    }
  
    protected processUpdateSubmissionLicense(
      response: Response
    ): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<boolean>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    sendAgentInvite(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: SendAgentInviteRequest | undefined
    ): Promise<boolean> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/contractsManagement/SendAgentInvite";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processSendAgentInvite(_response);
      });
    }
  
    protected processSendAgentInvite(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<boolean>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    downloadContracts(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: GetContractManagementRequest | undefined
    ): Promise<ReportFile> {
      let url_ =
        this.baseUrl + "/api/contracting/v{v}/contractsManagement/DownloadContracts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDownloadContracts(_response);
      });
    }
  
    protected processDownloadContracts(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param productYear (optional)
     * @param importName (optional)
     * @param importId (optional)
     * @param file (optional)
     * @return Success
     */
    upload(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      productYear?: number | undefined,
      importName?: string | null | undefined,
      importId?: number | undefined,
      file?: FileParameter | null | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/ImportAgentCertificate";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = new FormData();
      if (productYear === null || productYear === undefined)
        throw new Error("The parameter 'productYear' cannot be null.");
      else content_.append("ProductYear", productYear.toString());
      if (importName !== null && importName !== undefined)
        content_.append("ImportName", importName.toString());
      if (importId === null || importId === undefined)
        throw new Error("The parameter 'importId' cannot be null.");
      else content_.append("ImportId", importId.toString());
      if (file !== null && file !== undefined)
        content_.append(
          "File",
          file.data,
          file.fileName ? file.fileName : "File"
        );
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpload(_response);
      });
    }
  
    protected processUpload(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param fileName (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadFile(
      v: string,
      fileName?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<DownloadFileModel2> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/ImportAgentCertificate/downloadfile?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (fileName !== undefined && fileName !== null)
        url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDownloadFile(_response);
      });
    }
  
    protected processDownloadFile(
      response: Response
    ): Promise<DownloadFileModel2> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as DownloadFileModel2);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<DownloadFileModel2>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getImportForValues(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/ImportAgentCertificate/getimportforvalues";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetImportForValues(_response);
      });
    }
  
    protected processGetImportForValues(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLevel(
      contractid: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LevelResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/levels/searchbycontract/{contractid}";
      if (contractid === undefined || contractid === null)
        throw new Error("The parameter 'contractid' must be defined.");
      url_ = url_.replace("{contractid}", encodeURIComponent("" + contractid));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLevel(_response);
      });
    }
  
    protected processGetAllLevel(response: Response): Promise<LevelResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LevelResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LevelResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLevelById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LevelDetailModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/levelbyid/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLevelById(_response);
      });
    }
  
    protected processGetLevelById(response: Response): Promise<LevelDetailModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LevelDetailModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createLevel(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateLevelRequest | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateLevel(_response);
      });
    }
  
    protected processCreateLevel(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateLevel(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CreateUpdateLevelRequest | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateLevel(_response);
      });
    }
  
    protected processUpdateLevel(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    createBuildAll(
      levelid: number,
      productsubcategoryid: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<number> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/levels/{levelid}/BuildAll/{productsubcategoryid}";
      if (levelid === undefined || levelid === null)
        throw new Error("The parameter 'levelid' must be defined.");
      url_ = url_.replace("{levelid}", encodeURIComponent("" + levelid));
      if (productsubcategoryid === undefined || productsubcategoryid === null)
        throw new Error("The parameter 'productsubcategoryid' must be defined.");
      url_ = url_.replace(
        "{productsubcategoryid}",
        encodeURIComponent("" + productsubcategoryid)
      );
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateBuildAll(_response);
      });
    }
  
    protected processCreateBuildAll(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param uplineLicenseId (optional)
     * @param downlineLicenseId (optional)
     * @param payoutLevelId (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    cloneProductDetails(
      v: string,
      uplineLicenseId?: number | undefined,
      downlineLicenseId?: number | undefined,
      payoutLevelId?: number | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/cloneproductdetails?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (uplineLicenseId === null)
        throw new Error("The parameter 'uplineLicenseId' cannot be null.");
      else if (uplineLicenseId !== undefined)
        url_ +=
          "UplineLicenseId=" + encodeURIComponent("" + uplineLicenseId) + "&";
      if (downlineLicenseId === null)
        throw new Error("The parameter 'downlineLicenseId' cannot be null.");
      else if (downlineLicenseId !== undefined)
        url_ +=
          "DownlineLicenseId=" + encodeURIComponent("" + downlineLicenseId) + "&";
      if (payoutLevelId === null)
        throw new Error("The parameter 'payoutLevelId' cannot be null.");
      else if (payoutLevelId !== undefined)
        url_ += "PayoutLevelId=" + encodeURIComponent("" + payoutLevelId) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCloneProductDetails(_response);
      });
    }
  
    protected processCloneProductDetails(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteLevel(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<DeleteResponse2> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteLevel(_response);
      });
    }
  
    protected processDeleteLevel(response: Response): Promise<DeleteResponse2> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as DeleteResponse2);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          result400 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Bad Request",
            status,
            _responseText,
            _headers,
            result400
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketersLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/marketerslookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetMarketersLookup(_response);
      });
    }
  
    protected processGetMarketersLookup(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMarketers(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/allmarketerslookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllMarketers(_response);
      });
    }
  
    protected processGetAllMarketers(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param companyId (optional)
     * @param payoutLevelId (optional)
     * @param productId (optional)
     * @param liceneId (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPayoutLevelLookup(
      v: string,
      companyId?: number | undefined,
      payoutLevelId?: number | undefined,
      productId?: number | undefined,
      liceneId?: number | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LevelsLookupResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/lookup?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
        throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (payoutLevelId === null)
        throw new Error("The parameter 'payoutLevelId' cannot be null.");
      else if (payoutLevelId !== undefined)
        url_ += "PayoutLevelId=" + encodeURIComponent("" + payoutLevelId) + "&";
      if (productId === null)
        throw new Error("The parameter 'productId' cannot be null.");
      else if (productId !== undefined)
        url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
      if (liceneId === null)
        throw new Error("The parameter 'liceneId' cannot be null.");
      else if (liceneId !== undefined)
        url_ += "LiceneId=" + encodeURIComponent("" + liceneId) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetPayoutLevelLookup(_response);
      });
    }
  
    protected processGetPayoutLevelLookup(
      response: Response
    ): Promise<LevelsLookupResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LevelsLookupResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LevelsLookupResponse>(null as any);
    }
  
    /**
     * @param marketerId (optional)
     * @param payoutLevelId (optional)
     * @param categoryIds (optional)
     * @param subCategoryIds (optional)
     * @param licenseId (optional)
     * @param notes (optional)
     * @param sortOrder (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductPaidCommission(
      v: string,
      marketerId?: number | undefined,
      payoutLevelId?: number | undefined,
      categoryIds?: number[] | null | undefined,
      subCategoryIds?: number[] | null | undefined,
      licenseId?: number | undefined,
      notes?: string | null | undefined,
      sortOrder?: number | null | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ProductPaidCommissionResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/getproductpaidcommission?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (marketerId === null)
        throw new Error("The parameter 'marketerId' cannot be null.");
      else if (marketerId !== undefined)
        url_ += "MarketerId=" + encodeURIComponent("" + marketerId) + "&";
      if (payoutLevelId === null)
        throw new Error("The parameter 'payoutLevelId' cannot be null.");
      else if (payoutLevelId !== undefined)
        url_ += "PayoutLevelId=" + encodeURIComponent("" + payoutLevelId) + "&";
      if (categoryIds !== undefined && categoryIds !== null)
        categoryIds &&
          categoryIds.forEach((item) => {
            url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&";
          });
      if (subCategoryIds !== undefined && subCategoryIds !== null)
        subCategoryIds &&
          subCategoryIds.forEach((item) => {
            url_ += "SubCategoryIds=" + encodeURIComponent("" + item) + "&";
          });
      if (licenseId === null)
        throw new Error("The parameter 'licenseId' cannot be null.");
      else if (licenseId !== undefined)
        url_ += "LicenseId=" + encodeURIComponent("" + licenseId) + "&";
      if (notes !== undefined && notes !== null)
        url_ += "Notes=" + encodeURIComponent("" + notes) + "&";
      if (sortOrder !== undefined && sortOrder !== null)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetProductPaidCommission(_response);
      });
    }
  
    protected processGetProductPaidCommission(
      response: Response
    ): Promise<ProductPaidCommissionResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProductPaidCommissionResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ProductPaidCommissionResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLevelNote(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LevelNoteResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/levelnotes/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLevelNote(_response);
      });
    }
  
    protected processGetLevelNote(
      response: Response
    ): Promise<LevelNoteResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LevelNoteResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    deleteAllSelectedProductsByLevel(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: DeleteRequest | undefined
    ): Promise<DeleteProductsByLevelResponse[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/levels/deleteallselectedproductsbylevel";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteAllSelectedProductsByLevel(_response);
      });
    }
  
    protected processDeleteAllSelectedProductsByLevel(
      response: Response
    ): Promise<DeleteProductsByLevelResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as DeleteProductsByLevelResponse[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<DeleteProductsByLevelResponse[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getInconsistencyContracts(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: InconsistencyContractsRequest | undefined
    ): Promise<InconsistencyContractsResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/levels/getinconsistencycontracts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetInconsistencyContracts(_response);
      });
    }
  
    protected processGetInconsistencyContracts(
      response: Response
    ): Promise<InconsistencyContractsResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as InconsistencyContractsResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<InconsistencyContractsResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getInconsistencyAgentsForAutoRTS(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: InconsistencyAgentsRequest | undefined
    ): Promise<InconsistencyAgentsResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/levels/getinconsistencyagentsforautorts";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetInconsistencyAgentsForAutoRTS(_response);
      });
    }
  
    protected processGetInconsistencyAgentsForAutoRTS(
      response: Response
    ): Promise<InconsistencyAgentsResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as InconsistencyAgentsResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<InconsistencyAgentsResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getLookupsForInconsistencyContract(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LookupsForInconsistencyContractRequest | undefined
    ): Promise<LookupsForInconsistencyContractResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/levels/getlookupsforinconsistencycontract";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLookupsForInconsistencyContract(_response);
      });
    }
  
    protected processGetLookupsForInconsistencyContract(
      response: Response
    ): Promise<LookupsForInconsistencyContractResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LookupsForInconsistencyContractResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LookupsForInconsistencyContractResponse>(
        null as any
      );
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllImportPersistencyLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistency/importlookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllImportPersistencyLookup(_response);
      });
    }
  
    protected processGetAllImportPersistencyLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param licensePersistencyId (optional)
     * @param file (optional)
     * @return Success
     */
    importPersistencyTypes(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      licensePersistencyId?: number | undefined,
      file?: FileParameter | null | undefined
    ): Promise<ReportFile> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/licensepersistency/importpersistencytypes";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = new FormData();
      if (licensePersistencyId === null || licensePersistencyId === undefined)
        throw new Error("The parameter 'licensePersistencyId' cannot be null.");
      else
        content_.append("LicensePersistencyId", licensePersistencyId.toString());
      if (file !== null && file !== undefined)
        content_.append(
          "File",
          file.data,
          file.fileName ? file.fileName : "File"
        );
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processImportPersistencyTypes(_response);
      });
    }
  
    protected processImportPersistencyTypes(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLicensePersistency(
      licenseId: number,
      v: string,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LatestLicensePersistencyResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/licensepersistency/getalllicensepersistency/{licenseId}?";
      if (licenseId === undefined || licenseId === null)
        throw new Error("The parameter 'licenseId' must be defined.");
      url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLicensePersistency(_response);
      });
    }
  
    protected processGetAllLicensePersistency(
      response: Response
    ): Promise<LatestLicensePersistencyResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LatestLicensePersistencyResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LatestLicensePersistencyResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicensePersistencyHistory(
      licenseId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LatestLicensePersistencyResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/licensepersistency/licensepersistencyhistory/{licenseId}";
      if (licenseId === undefined || licenseId === null)
        throw new Error("The parameter 'licenseId' must be defined.");
      url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicensePersistencyHistory(_response);
      });
    }
  
    protected processGetLicensePersistencyHistory(
      response: Response
    ): Promise<LatestLicensePersistencyResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LatestLicensePersistencyResponse);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicensePersistencyById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LicensePersistencyModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistency/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicensePersistencyById(_response);
      });
    }
  
    protected processGetLicensePersistencyById(
      response: Response
    ): Promise<LicensePersistencyModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicensePersistencyModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteLicensePersistency(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistency/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteLicensePersistency(_response);
      });
    }
  
    protected processDeleteLicensePersistency(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createLicensePersistency(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicensePersistencyModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistency";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateLicensePersistency(_response);
      });
    }
  
    protected processCreateLicensePersistency(
      response: Response
    ): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateLicensePersistency(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicensePersistencyModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistency";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateLicensePersistency(_response);
      });
    }
  
    protected processUpdateLicensePersistency(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param licensePersistencyTypeId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicensePersistencyTypeColoringRule(
      v: string,
      licensePersistencyTypeId?: number | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AllColoringRulesResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/LicensePersistencyTypeColoringRule?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (licensePersistencyTypeId === null)
        throw new Error(
          "The parameter 'licensePersistencyTypeId' cannot be null."
        );
      else if (licensePersistencyTypeId !== undefined)
        url_ +=
          "LicensePersistencyTypeId=" +
          encodeURIComponent("" + licensePersistencyTypeId) +
          "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicensePersistencyTypeColoringRule(_response);
      });
    }
  
    protected processGetLicensePersistencyTypeColoringRule(
      response: Response
    ): Promise<AllColoringRulesResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AllColoringRulesResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<AllColoringRulesResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createLicensePersistencyTypeColoringRule(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ColoringRuleModel | undefined
    ): Promise<number> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/LicensePersistencyTypeColoringRule";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateLicensePersistencyTypeColoringRule(_response);
      });
    }
  
    protected processCreateLicensePersistencyTypeColoringRule(
      response: Response
    ): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateLicensePersistencyTypeColoringRule(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ColoringRuleModel | undefined
    ): Promise<void> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/LicensePersistencyTypeColoringRule";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateLicensePersistencyTypeColoringRule(_response);
      });
    }
  
    protected processUpdateLicensePersistencyTypeColoringRule(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicensePersistencyTypeColoringRuleById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ColoringRuleModel> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/LicensePersistencyTypeColoringRule/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicensePersistencyTypeColoringRuleById(_response);
      });
    }
  
    protected processGetLicensePersistencyTypeColoringRuleById(
      response: Response
    ): Promise<ColoringRuleModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ColoringRuleModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteLicensePersistencyTypeColoringRule(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/LicensePersistencyTypeColoringRule/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteLicensePersistencyTypeColoringRule(_response);
      });
    }
  
    protected processDeleteLicensePersistencyTypeColoringRule(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param companyId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLicensePersistencyTypes(
      v: string,
      companyId?: number | null | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LicensePersistencyTypeResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistencytypes?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId !== undefined && companyId !== null)
        url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLicensePersistencyTypes(_response);
      });
    }
  
    protected processGetAllLicensePersistencyTypes(
      response: Response
    ): Promise<LicensePersistencyTypeResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicensePersistencyTypeResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LicensePersistencyTypeResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createLicensePersistencyType(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicensePersistencyTypeModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistencytypes";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateLicensePersistencyType(_response);
      });
    }
  
    protected processCreateLicensePersistencyType(
      response: Response
    ): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateLicensePersistencyType(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicensePersistencyTypeModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistencytypes";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateLicensePersistencyType(_response);
      });
    }
  
    protected processUpdateLicensePersistencyType(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLicensePersistencyLookup(
      licenseId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/licensepersistencytypes/getlicensepersistencylookup/{licenseId}";
      if (licenseId === undefined || licenseId === null)
        throw new Error("The parameter 'licenseId' must be defined.");
      url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLicensePersistencyLookup(_response);
      });
    }
  
    protected processGetAllLicensePersistencyLookup(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicensePersistencyTypeById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LicensePersistencyTypeModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistencytypes/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicensePersistencyTypeById(_response);
      });
    }
  
    protected processGetLicensePersistencyTypeById(
      response: Response
    ): Promise<LicensePersistencyTypeModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicensePersistencyTypeModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteLicensePersistencyType(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensepersistencytypes/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteLicensePersistencyType(_response);
      });
    }
  
    protected processDeleteLicensePersistencyType(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param licensePersistencyTypeId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllColoringRules(
      v: string,
      licensePersistencyTypeId?: number | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AllColoringRulesResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/licensepersistencytypes/allcoloringrules?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (licensePersistencyTypeId === null)
        throw new Error(
          "The parameter 'licensePersistencyTypeId' cannot be null."
        );
      else if (licensePersistencyTypeId !== undefined)
        url_ +=
          "LicensePersistencyTypeId=" +
          encodeURIComponent("" + licensePersistencyTypeId) +
          "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllColoringRules(_response);
      });
    }
  
    protected processGetAllColoringRules(
      response: Response
    ): Promise<AllColoringRulesResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AllColoringRulesResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<AllColoringRulesResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getColoringRuleById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ColoringRuleModel> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/licensepersistencytypes/coloringrulesbyid/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetColoringRuleById(_response);
      });
    }
  
    protected processGetColoringRuleById(
      response: Response
    ): Promise<ColoringRuleModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ColoringRuleModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    saveSplittLicense(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: SaveSplittLicenseRequest | undefined
    ): Promise<LicenseSplitterResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/licensesplitter/savesplittlicense";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processSaveSplittLicense(_response);
      });
    }
  
    protected processSaveSplittLicense(
      response: Response
    ): Promise<LicenseSplitterResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicenseSplitterResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LicenseSplitterResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    buildAllLevel(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: BuildAllCommandRequest | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensesplitter/buildalllevel";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processBuildAllLevel(_response);
      });
    }
  
    protected processBuildAllLevel(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentByAgentId(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AgentModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensesplitter/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAgentByAgentId(_response);
      });
    }
  
    protected processGetAgentByAgentId(response: Response): Promise<AgentModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AgentModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicenseIdByNumber(
      licenseNumber: string | null,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<number> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/licensesplitter/GetLicenseIdByNumber/{licenseNumber}";
      if (licenseNumber === undefined || licenseNumber === null)
        throw new Error("The parameter 'licenseNumber' must be defined.");
      url_ = url_.replace(
        "{licenseNumber}",
        encodeURIComponent("" + licenseNumber)
      );
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicenseIdByNumber(_response);
      });
    }
  
    protected processGetLicenseIdByNumber(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param licenseId (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLicenseStates(
      v: string,
      licenseId?: number | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LicenseStateSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestate?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (licenseId === null)
        throw new Error("The parameter 'licenseId' cannot be null.");
      else if (licenseId !== undefined)
        url_ += "LicenseId=" + encodeURIComponent("" + licenseId) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLicenseStates(_response);
      });
    }
  
    protected processGetAllLicenseStates(
      response: Response
    ): Promise<LicenseStateSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicenseStateSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LicenseStateSearchResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addLicenseState(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicenseStateModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestate";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddLicenseState(_response);
      });
    }
  
    protected processAddLicenseState(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateLicenseState(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicenseStateModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestate";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateLicenseState(_response);
      });
    }
  
    protected processUpdateLicenseState(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicenseStateById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LicenseStateModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestate/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicenseStateById(_response);
      });
    }
  
    protected processGetLicenseStateById(
      response: Response
    ): Promise<LicenseStateModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicenseStateModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteLicenseState(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestate/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteLicenseState(_response);
      });
    }
  
    protected processDeleteLicenseState(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLicenseStatusReasons(
      v: string,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LicenseStatusReasonsSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestatusreason?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLicenseStatusReasons(_response);
      });
    }
  
    protected processGetAllLicenseStatusReasons(
      response: Response
    ): Promise<LicenseStatusReasonsSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicenseStatusReasonsSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LicenseStatusReasonsSearchResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addLicenseStatusReason(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicenseStatusReasonModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestatusreason";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddLicenseStatusReason(_response);
      });
    }
  
    protected processAddLicenseStatusReason(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateLicenseStatusReason(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicenseStatusReasonModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestatusreason";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateLicenseStatusReason(_response);
      });
    }
  
    protected processUpdateLicenseStatusReason(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicenseStatusReasonById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LicenseStatusReasonModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestatusreason/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicenseStatusReasonById(_response);
      });
    }
  
    protected processGetLicenseStatusReasonById(
      response: Response
    ): Promise<LicenseStatusReasonModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LicenseStatusReasonModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    deleteLicenseStatusReason(
      v: string,
      id: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: number | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestatusreason/{id}";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteLicenseStatusReason(_response);
      });
    }
  
    protected processDeleteLicenseStatusReason(
      response: Response
    ): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param id (optional)
     * @param reason (optional)
     * @param statusId (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    isLicenseStatusReasonExists(
      v: string,
      id?: number | undefined,
      reason?: string | null | undefined,
      statusId?: number | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<boolean> {
      let url_ = this.baseUrl + "/api/contract/v{v}/licensestatusreason/exists?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (id === null) throw new Error("The parameter 'id' cannot be null.");
      else if (id !== undefined)
        url_ += "Id=" + encodeURIComponent("" + id) + "&";
      if (reason !== undefined && reason !== null)
        url_ += "Reason=" + encodeURIComponent("" + reason) + "&";
      if (statusId === null)
        throw new Error("The parameter 'statusId' cannot be null.");
      else if (statusId !== undefined)
        url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processIsLicenseStatusReasonExists(_response);
      });
    }
  
    protected processIsLicenseStatusReasonExists(
      response: Response
    ): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<boolean>(null as any);
    }
  
    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllLocation(
      contractid: number,
      v: string,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LocationResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/locations/{contractid}?";
      if (contractid === undefined || contractid === null)
        throw new Error("The parameter 'contractid' must be defined.");
      url_ = url_.replace("{contractid}", encodeURIComponent("" + contractid));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllLocation(_response);
      });
    }
  
    protected processGetAllLocation(
      response: Response
    ): Promise<LocationResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LocationResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LocationResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    createLocation(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LocationCreateRequest | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/locations";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processCreateLocation(_response);
      });
    }
  
    protected processCreateLocation(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteLocation(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/locations/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteLocation(_response);
      });
    }
  
    protected processDeleteLocation(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param searchFor (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLocationLookup(
      v: string,
      searchFor?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<LocationDBAResponse[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/locations/lookup?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (searchFor !== undefined && searchFor !== null)
        url_ += "searchFor=" + encodeURIComponent("" + searchFor) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLocationLookup(_response);
      });
    }
  
    protected processGetLocationLookup(
      response: Response
    ): Promise<LocationDBAResponse[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LocationDBAResponse[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<LocationDBAResponse[]>(null as any);
    }
  
    /**
     * @param npn (optional)
     * @param searchConditions (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllRtsCertifications(
      v: string,
      npn?: string | null | undefined,
      searchConditions?: string | null | undefined,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<AppointmentResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/manageRts?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (npn !== undefined && npn !== null)
        url_ += "Npn=" + encodeURIComponent("" + npn) + "&";
      if (searchConditions !== undefined && searchConditions !== null)
        url_ +=
          "SearchConditions=" + encodeURIComponent("" + searchConditions) + "&";
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllRtsCertifications(_response);
      });
    }
  
    protected processGetAllRtsCertifications(
      response: Response
    ): Promise<AppointmentResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AppointmentResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<AppointmentResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRtsCertificationByNpn(
      npn: string | null,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<RtsDataModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/manageRts/{npn}";
      if (npn === undefined || npn === null)
        throw new Error("The parameter 'npn' must be defined.");
      url_ = url_.replace("{npn}", encodeURIComponent("" + npn));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetRtsCertificationByNpn(_response);
      });
    }
  
    protected processGetRtsCertificationByNpn(
      response: Response
    ): Promise<RtsDataModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as RtsDataModel);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<RtsDataModel>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addRtsCertification(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: RtsCertificationModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/manageRts/AddRtsCertification";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddRtsCertification(_response);
      });
    }
  
    protected processAddRtsCertification(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateRtsCertification(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: RtsCertificationModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/manageRts/UpdateRtsCertification";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateRtsCertification(_response);
      });
    }
  
    protected processUpdateRtsCertification(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    deleteRtsCertification(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: RtsCertificationModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/manageRts/DeleteRtsCertification";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteRtsCertification(_response);
      });
    }
  
    protected processDeleteRtsCertification(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRtsStatusLookup(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/manageRts/rtsstatuslookup";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetRtsStatusLookup(_response);
      });
    }
  
    protected processGetRtsStatusLookup(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRtsCarrierGroupLookup(
      agentid: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItemSelect[]> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/manageRts/{agentid}/carriergrouplookup";
      if (agentid === undefined || agentid === null)
        throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetRtsCarrierGroupLookup(_response);
      });
    }
  
    protected processGetRtsCarrierGroupLookup(
      response: Response
    ): Promise<ListItemSelect[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ListItemSelect[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItemSelect[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRtsProductsByCarrier(
      agentid: number,
      carrierGroupId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ProductsByCarrierResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/manageRts/{agentid}/productslookupbycarrier/{carrierGroupId}";
      if (agentid === undefined || agentid === null)
        throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (carrierGroupId === undefined || carrierGroupId === null)
        throw new Error("The parameter 'carrierGroupId' must be defined.");
      url_ = url_.replace(
        "{carrierGroupId}",
        encodeURIComponent("" + carrierGroupId)
      );
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetRtsProductsByCarrier(_response);
      });
    }
  
    protected processGetRtsProductsByCarrier(
      response: Response
    ): Promise<ProductsByCarrierResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProductsByCarrierResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ProductsByCarrierResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContactCount(
      agentId: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<boolean> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/manageRts/contractcount/{agentId}";
      if (agentId === undefined || agentId === null)
        throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContactCount(_response);
      });
    }
  
    protected processGetContactCount(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getToken(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<TokenResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/manageRts/gettoken";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetToken(_response);
      });
    }
  
    protected processGetToken(response: Response): Promise<TokenResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as TokenResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<TokenResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getActiveCarriers(
      npn: string | null,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ActiveCarrierResponse> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/manageRts/activecontractcarriers/{npn}";
      if (npn === undefined || npn === null)
        throw new Error("The parameter 'npn' must be defined.");
      url_ = url_.replace("{npn}", encodeURIComponent("" + npn));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetActiveCarriers(_response);
      });
    }
  
    protected processGetActiveCarriers(
      response: Response
    ): Promise<ActiveCarrierResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ActiveCarrierResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ActiveCarrierResponse>(null as any);
    }
  
    /**
     * @param pageIndex (optional)
     * @param pageSize (optional)
     * @param sortColumn (optional)
     * @param sortAscending (optional)
     * @param fullTextFilter (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMarketerMailConfigs(
      v: string,
      pageIndex?: number | undefined,
      pageSize?: number | undefined,
      sortColumn?: string | null | undefined,
      sortAscending?: boolean | undefined,
      fullTextFilter?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<MarketerMailConfigsSearchResponse> {
      let url_ = this.baseUrl + "/api/contract/v{v}/marketermailconfig?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
        throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
        url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
        url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
        throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
        url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
        url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllMarketerMailConfigs(_response);
      });
    }
  
    protected processGetAllMarketerMailConfigs(
      response: Response
    ): Promise<MarketerMailConfigsSearchResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as MarketerMailConfigsSearchResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<MarketerMailConfigsSearchResponse>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    addMarketerMailConfig(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: MarketerMailConfigModel | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + "/api/contract/v{v}/marketermailconfig";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processAddMarketerMailConfig(_response);
      });
    }
  
    protected processAddMarketerMailConfig(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 201) {
        return response.text().then((_responseText) => {
          let result201: any = null;
          result201 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as number);
          return result201;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<number>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateMarketerMailConfig(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: MarketerMailConfigModel | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/marketermailconfig";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "PUT",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processUpdateMarketerMailConfig(_response);
      });
    }
  
    protected processUpdateMarketerMailConfig(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketerMailConfigById(
      id: number,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<MarketerMailConfigModel> {
      let url_ = this.baseUrl + "/api/contract/v{v}/marketermailconfig/{id}";
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetMarketerMailConfigById(_response);
      });
    }
  
    protected processGetMarketerMailConfigById(
      response: Response
    ): Promise<MarketerMailConfigModel> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as MarketerMailConfigModel);
          return result200;
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Not Found",
            status,
            _responseText,
            _headers,
            result404
          );
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else {
        return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ProblemDetails);
          return throwException(
            "Error",
            status,
            _responseText,
            _headers,
            resultdefault
          );
        });
      }
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    deleteMarketerMailConfig(
      v: string,
      id: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: number | undefined
    ): Promise<void> {
      let url_ = this.baseUrl + "/api/contract/v{v}/marketermailconfig/{id}";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "DELETE",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDeleteMarketerMailConfig(_response);
      });
    }
  
    protected processDeleteMarketerMailConfig(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 204) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<void>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getContractInviteReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractInviteRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/contractinvite";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractInviteReport(_response);
      });
    }
  
    protected processGetContractInviteReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getContractingSentReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractingSentRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/contractingsent";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractingSentReport(_response);
      });
    }
  
    protected processGetContractingSentReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getContractingSentNoFUPIn30DaysReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractingSentNoFUPIn30DaysRequest | undefined
    ): Promise<ReportFile> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/reports/contractingsentnofupin30days";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractingSentNoFUPIn30DaysReport(_response);
      });
    }
  
    protected processGetContractingSentNoFUPIn30DaysReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getDownlineAgentsReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: DownlineAgentsRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/downlineagents";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetDownlineAgentsReport(_response);
      });
    }
  
    protected processGetDownlineAgentsReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getContractsByMarketerReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractsByMarketerRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/contractsbymarketer";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractsByMarketerReport(_response);
      });
    }
  
    protected processGetContractsByMarketerReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getContractsWithNoBusinessReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractsWithNoBusinessRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/contractswithnobusiness";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractsWithNoBusinessReport(_response);
      });
    }
  
    protected processGetContractsWithNoBusinessReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getCarrierUpdatesReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: CarrierUpdatesRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/carrierupdates";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetCarrierUpdatesReport(_response);
      });
    }
  
    protected processGetCarrierUpdatesReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getFaxConfirmationReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: FaxConfirmationRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/faxconfirmation";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetFaxConfirmationReport(_response);
      });
    }
  
    protected processGetFaxConfirmationReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getLicenseCountByCompanyReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: LicenseCountByCompanyRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/licensecountbycompany";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetLicenseCountByCompanyReport(_response);
      });
    }
  
    protected processGetLicenseCountByCompanyReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getOrdersByDivisionReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: OrdersByDivisionRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/ordersbydivision";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetOrdersByDivisionReport(_response);
      });
    }
  
    protected processGetOrdersByDivisionReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    getContractDetailsReport(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined,
      body?: ContractDetailsRequest | undefined
    ): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/contract/v{v}/reports/contractdetails";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      const content_ = JSON.stringify(body);
  
      let options_: RequestInit = {
        body: content_,
        method: "POST",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractDetailsReport(_response);
      });
    }
  
    protected processGetContractDetailsReport(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllResidencyStatus(
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/contract/v{v}/residencystatus";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetAllResidencyStatus(_response);
      });
    }
  
    protected processGetAllResidencyStatus(
      response: Response
    ): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ListItem[]);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ListItem[]>(null as any);
    }
  
    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractSummaries(
      contractId: number,
      includeTerminatedDownlines: boolean,
      v: string,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<SummaryResponse> {
      let url_ =
        this.baseUrl +
        "/api/contract/v{v}/summaries/{contractId}/{includeTerminatedDownlines}";
      if (contractId === undefined || contractId === null)
        throw new Error("The parameter 'contractId' must be defined.");
      url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
      if (
        includeTerminatedDownlines === undefined ||
        includeTerminatedDownlines === null
      )
        throw new Error(
          "The parameter 'includeTerminatedDownlines' must be defined."
        );
      url_ = url_.replace(
        "{includeTerminatedDownlines}",
        encodeURIComponent("" + includeTerminatedDownlines)
      );
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processGetContractSummaries(_response);
      });
    }
  
    protected processGetContractSummaries(
      response: Response
    ): Promise<SummaryResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as SummaryResponse);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<SummaryResponse>(null as any);
    }
  
    /**
     * @param contractId (optional)
     * @param includeTerminatedDownlines (optional)
     * @param searchText (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadContractSummaries(
      v: string,
      contractId?: number | undefined,
      includeTerminatedDownlines?: boolean | undefined,
      searchText?: string | null | undefined,
      impersonated_User?: any | undefined,
      hOSTNAME?: any | undefined
    ): Promise<ReportFile> {
      let url_ =
        this.baseUrl + "/api/contract/v{v}/summaries/downloadcontractsummaries?";
      if (v === undefined || v === null)
        throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (contractId === null)
        throw new Error("The parameter 'contractId' cannot be null.");
      else if (contractId !== undefined)
        url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
      if (includeTerminatedDownlines === null)
        throw new Error(
          "The parameter 'includeTerminatedDownlines' cannot be null."
        );
      else if (includeTerminatedDownlines !== undefined)
        url_ +=
          "includeTerminatedDownlines=" +
          encodeURIComponent("" + includeTerminatedDownlines) +
          "&";
      if (searchText !== undefined && searchText !== null)
        url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
      url_ = url_.replace(/[?&]$/, "");
  
      let options_: RequestInit = {
        method: "GET",
        headers: {
          Impersonated_User:
            impersonated_User !== undefined && impersonated_User !== null
              ? "" + impersonated_User
              : "",
          HOSTNAME:
            hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          Accept: "text/plain",
        },
      };
  
      return this.http.fetch(url_, options_).then((_response: Response) => {
        return this.processDownloadContractSummaries(_response);
      });
    }
  
    protected processDownloadContractSummaries(
      response: Response
    ): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReportFile);
          return result200;
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          return throwException(
            "If Authorization header not present, has no value or no valid jwt bearer token",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          return throwException(
            "If user not authorized to perform requested action",
            status,
            _responseText,
            _headers
          );
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        });
      }
      return Promise.resolve<ReportFile>(null as any);
    }
  }
  
  export interface AddressListModel {
    id?: number;
    addressType?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    zip?: string | undefined;
  }
  
  export interface AddressSearchResponse {
    recordCount?: number;
    emailAllRecords?: AddressListModel[] | undefined;
    data?: AddressListModel[] | undefined;
  }
  
  export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
  
    [key: string]: any;
  }
  
  export interface CreateUpdateAddressModel {
    id?: number;
    companyId?: number;
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    zipCode?: string | undefined;
    cityName?: string | undefined;
    stateAbbreviation?: string | undefined;
    countyName?: string | undefined;
    addressType?: number;
    dateCreated?: Date;
    userId?: number;
  }
  
  export interface AddressModel {
    id?: number;
    companyId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    zipCode?: string | undefined;
    cityName?: string | undefined;
    stateAbbreviation?: string | undefined;
    countyName?: string | undefined;
    addressType?: number;
  }
  
  export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
    hidden?: boolean;
  }
  
  export interface AppointmentSearchListModel {
    id?: number;
    companyName?: string | undefined;
    state?: string | undefined;
    appointmentNote?: string | undefined;
    effectiveDate?: Date;
  }
  
  export interface AppointmentResponse {
    recordCount?: number;
    emailAllRecords?: AppointmentSearchListModel[] | undefined;
    data?: AppointmentSearchListModel[] | undefined;
    agentNPN?: string | undefined;
    agentName?: string | undefined;
  }
  
  export interface CreateUpdateAppointmentModel {
    id?: number;
    agentId?: number;
    companyId?: number;
    effectiveDate?: Date;
    appointmentNote?: string | undefined;
    states?: string[] | undefined;
  }
  
  export interface AppointmentDetailModel {
    appointmentId?: number;
    agentId?: number;
    agentName?: string | undefined;
    companyName?: string | undefined;
    effectiveDate?: Date;
    state?: string | undefined;
    appointmentNote?: string | undefined;
    companyId?: number;
  }
  
  export interface StatesResponse {
    stateId?: number;
    stateName?: string | undefined;
    abbreviation?: string | undefined;
    selected?: boolean;
    isHeader?: boolean;
  }
  
  export interface CompanyResponse {
    companyId?: number;
    companyName?: string | undefined;
  }
  
  export interface BulkMailShippingResponse {
    shippingNumber?: string | undefined;
  }
  
  export interface CarrierByAgentListModel {
    carrierId?: number;
    carrierName?: string | undefined;
    carrierAbbreviation?: string | undefined;
    carrierIsActive?: boolean;
  }
  
  export interface GetAgentPolicyScreenLookupsResponse {
    carriers?: CarrierByAgentListModel[] | undefined;
    status?: ListItem[] | undefined;
  }
  
  export interface CarrierByAgentListModel2 {
    carrierId?: number;
    carrierName?: string | undefined;
    carrierAbbreviation?: string | undefined;
    carrierIsActive?: boolean;
  }
  
  export interface CarriersByAgentResponse {
    recordCount?: number;
    emailAllRecords?: CarrierByAgentListModel2[] | undefined;
    data?: CarrierByAgentListModel2[] | undefined;
  }
  
  export interface CarrierListModel {
    carrierId?: number;
    carrierName?: string | undefined;
    carrierAbbreviation?: string | undefined;
    shortName?: string | undefined;
    isHidden?: boolean;
    carrierGroup?: string | undefined;
  }
  
  export interface CarrierSearchResponse {
    recordCount?: number;
    emailAllRecords?: CarrierListModel[] | undefined;
    data?: CarrierListModel[] | undefined;
  }
  
  export interface MasterCarrierModel {
    id?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    groupId?: number;
    carrierGroupName?: string | undefined;
  }
  
  export interface MasterCarrierGroupModel {
    id?: string;
    name?: string | undefined;
    carrierGroupName?: string | undefined;
  }
  
  export interface CarrierGroupModel {
    id?: number;
    groupName?: string | undefined;
    hidden?: boolean;
  }
  
  export interface CarrierGroupsListModel {
    id?: number;
    groupName?: string | undefined;
    hidden?: boolean;
  }
  
  export interface CarrierGroupsSearchResponse {
    recordCount?: number;
    emailAllRecords?: CarrierGroupsListModel[] | undefined;
    data?: CarrierGroupsListModel[] | undefined;
  }

  export interface MasterCarrierResponse {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    status?: string | undefined;
  }

  export interface MasterCarrierGroupResponse {
      id?: number;
      name?: string | undefined;
      status?: string | undefined;
      carriers?: MasterCarrierResponse[] | undefined;
  }
  
  export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
  }
  
  export interface CarrierListModel2 {
    id?: number;
    carrierName?: string | undefined;
    shortName?: string | undefined;
    isHidden?: boolean;
    carrierGroup?: string | undefined;
    createdDate?: Date | undefined;
    carrierGroupId?: number | undefined;
    writingNumberTypes?: string | undefined;
    masterCarrierName?: string | undefined;
    masterCarrierId?: number | undefined;
    masterCarrierGroupName?: string | undefined;
    masterCarrierGroupId?: number | undefined;
  }
  
  export interface AllCarriersResponse {
    recordCount?: number;
    emailAllRecords?: CarrierListModel2[] | undefined;
    data?: CarrierListModel2[] | undefined;
  }
  
  export interface WritingNumberDefaultsModel {
    id?: number;
    companyId?: number;
    licenseNumberTypeId?: number;
    isWritableDefault?: boolean;
    isWritableSelected?: boolean;
    typeName?: string | undefined;
  }
  
  export interface ContactModel {
    companyId?: number;
    id?: number;
    contactTypeId?: number;
    contactType?: string | undefined;
    contactValue?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    phoneTypeId?: number;
    notes?: string | undefined;
    emailTypeId?: number;
    alternativePointOfContactTypeId?: number;
    phoneType?: string | undefined;
    emailType?: string | undefined;
    alternativePointOfContactType?: string | undefined;
  }
  
  export interface AllContactResponse {
    recordCount?: number;
    emailAllRecords?: ContactModel[] | undefined;
    data?: ContactModel[] | undefined;
  }
  
  export interface CarrierByIdModel {
    id?: number;
    name?: string | undefined;
    carrierShortName?: string | undefined;
    carrierGroupId?: number | undefined;
    defaultPaymentSourceId?: number | undefined;
    commissionProcessingDivisionId?: number;
    checkEligibility?: boolean;
    status?: boolean;
    allowOverlappingDates?: boolean | undefined;
    strictContracting?: boolean;
    masterCarrierId?: string;
    masterCarrierName?: string | undefined;
    carrierGroupName?: string | undefined;
    writingNumberDefaults?: WritingNumberDefaultsModel[] | undefined;
    carrierGroups?: ListItem[] | undefined;
    paymentSource?: ListItem[] | undefined;
    addressType?: ListItem[] | undefined;
    state?: StatesResponse[] | undefined;
    carrierContacts?: AllContactResponse;
    carrierAddresses?: AddressSearchResponse;
    noteCount?: number;
    levelCount?: number;
    websiteCount?: number;
    productCount?: number;
  }
  
  export interface CompanyLicenseNumberDefaultModel {
    id?: number;
    companyId?: number;
    licenseNumberTypeId?: number;
    isWritableDefault?: boolean;
  }
  
  export interface CreateUpdateContactModel {
    id?: number;
    companyId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    notes?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    alternativePointOfContactTypeId?: number | undefined;
  }
  
  export interface CreateUpdateCarrierModel {
    id?: number;
    name?: string | undefined;
    carrierShortName?: string | undefined;
    carrierGroupId?: number | undefined;
    defaultPaymentSourceId?: number | undefined;
    commissionProcessingDivisionId?: number;
    checkEligibility?: boolean;
    status?: boolean;
    strictContracting?: boolean;
    allowOverlappingDates?: boolean | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    modifiedOn?: number | undefined;
    masterCarrierId?: string;
    companyLicenseNumberDefault?: CompanyLicenseNumberDefaultModel[] | undefined;
    contactList?: CreateUpdateContactModel[] | undefined;
    addressList?: CreateUpdateAddressModel[] | undefined;
  }
  
  export interface NoteModel {
    id?: number;
    companyId?: number;
    title?: string | undefined;
    note?: string | undefined;
    createdDate?: Date;
    createdDateForView?: string | undefined;
    createdDateForGrid?: string | undefined;
    modifiedDateForView?: string | undefined;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
  }
  
  export interface NotesSearchResponse {
    recordCount?: number;
    emailAllRecords?: NoteModel[] | undefined;
    data?: NoteModel[] | undefined;
  }
  
  export interface CreateUpdateNoteModel {
    id?: number;
    companyId?: number;
    title?: string | undefined;
    note?: string | undefined;
  }
  
  export interface CertificationsListModel {
    id?: number;
    fullName?: string | undefined;
    company?: string | undefined;
    product?: string | undefined;
    certificationDate?: Date;
    year?: number;
    user?: string | undefined;
    companyId?: number;
    note?: string | undefined;
    agentId?: number;
  }
  
  export interface CertificationsSearchResponse {
    recordCount?: number;
    emailAllRecords?: CertificationsListModel[] | undefined;
    data?: CertificationsListModel[] | undefined;
  }
  
  export interface CertificationModel {
    id?: number;
    agentId?: number;
    companyId?: number;
    productId?: number;
    productIds?: number[] | undefined;
    certificationDate?: Date;
    certificationYear?: number;
    note?: string | undefined;
    override?: boolean;
    companyName?: string | undefined;
    agentName?: string | undefined;
  }
  
  export interface CertificationsDropDownValuesResponse {
    company?: ListItem[] | undefined;
    year?: ListItem[] | undefined;
  }
  
  export interface CertificationsByAgentListModel {
    id?: number;
    company?: string | undefined;
    product?: string | undefined;
    certificationDate?: Date;
    year?: number;
    user?: string | undefined;
  }
  
  export interface CertificationsSearchByAgentResponse {
    recordCount?: number;
    emailAllRecords?: CertificationsByAgentListModel[] | undefined;
    data?: CertificationsByAgentListModel[] | undefined;
  }
  
  export interface ContractCommunicationSPModel {
    licenseCommunicationID?: number;
    communicationTypeName?: string | undefined;
    contactTypeID?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    licenseID?: number;
    communicationTypeID?: number;
    groupID?: number;
    agentContactID?: number;
    inheratance?: number;
    isPhoneUnsubscribed?: boolean | undefined;
  }
  
  export interface CommunicationResponse {
    recordCount?: number;
    emailAllRecords?: ContractCommunicationSPModel[] | undefined;
    data?: ContractCommunicationSPModel[] | undefined;
  }
  
  export interface CommunicationRequest {
    contractId?: number;
    agentContactId?: number | undefined;
    communicationTypeId?: number;
    inheritance?: number;
    addToHierarchyPockets?: boolean;
    createdDate?: Date;
    createdByUserId?: number;
  }
  
  export interface LongRunningMarketingEventGroup {
    id?: number;
    name?: string | undefined;
    marketingEvent?: MarketingEvent[] | undefined;
  }
  
  export interface MarketingEventType {
    id?: number;
    marketingEventTypeName?: string | undefined;
    marketingEvent?: MarketingEvent[] | undefined;
  }
  
  export interface MarketingFormat {
    id?: number;
    marketingFormatName?: string | undefined;
    marketingEvent?: MarketingEvent[] | undefined;
  }
  
  export interface EmailDomain {
    id?: number;
    domain?: string | undefined;
    isExcludedFromReports?: boolean | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    emailAddress?: EmailAddress[] | undefined;
  }
  
  export interface EmailAddress {
    id?: number;
    address?: string | undefined;
    emailDomainId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    emailDomain?: EmailDomain;
    marketingEventEmail?: MarketingEventEmail[] | undefined;
  }
  
  export interface MarketingEventEmail {
    id?: number;
    emailAddressId?: number;
    marketingEventEmailListId?: number;
    sent?: boolean | undefined;
    sentTime?: Date | undefined;
    canSend?: boolean;
    statusMessage?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    emailAddress?: EmailAddress;
    marketingEventEmailList?: MarketingEventEmailList;
  }
  
  export interface MarketingEventEmailList {
    id?: number;
    dateStart?: Date;
    userId?: number;
    dateEnd?: Date;
    marketingEventId?: number;
    sent?: boolean;
    listName?: string | undefined;
    isPaused?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    marketingEvent?: MarketingEvent;
    marketingEventEmail?: MarketingEventEmail[] | undefined;
  }
  
  export interface MarketingEvent {
    id?: number;
    marketingEventTypeId?: number;
    marketingFormatId?: number;
    ownerId?: number;
    companyId?: number;
    divisionId?: number;
    dateTimeStart?: Date;
    dateTimeEnd?: Date;
    title?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    audience?: string | undefined;
    requestorId?: number | undefined;
    audienceSize?: number | undefined;
    purchasedLead?: boolean | undefined;
    emailSubject?: string | undefined;
    fromEmailAddress?: string | undefined;
    fromDisplayName?: string | undefined;
    replyTo?: string | undefined;
    longRunningMarketingEventGroupId?: number | undefined;
    productLineId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    longRunningMarketingEventGroup?: LongRunningMarketingEventGroup;
    marketingEventType?: MarketingEventType;
    marketingFormat?: MarketingFormat;
    calllist?: Calllist[] | undefined;
    marketingEventEmailList?: MarketingEventEmailList[] | undefined;
  }
  
  export interface Calllist {
    id?: number;
    teamId?: number;
    calllistName?: string | undefined;
    userId?: number;
    createdDate?: Date;
    prospective?: boolean;
    exist?: boolean | undefined;
    marketingEventId?: number | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    marketingEvent?: MarketingEvent;
    users?: Users[] | undefined;
  }
  
  export interface Bank {
    bankId?: number;
    routingNumber?: string | undefined;
    bankName?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    bankAccounts?: BankAccounts[] | undefined;
  }
  
  export interface BankAccountPaymentMethod {
    bankAccountPaymentMethodId?: number;
    bankAccountPaymentMethodName?: string | undefined;
    sort?: number | undefined;
    bankAccounts?: BankAccounts[] | undefined;
  }
  
  export interface BankAccountType {
    bankAccountTypeId?: number;
    bankAccountTypeName?: string | undefined;
    bankAccounts?: BankAccounts[] | undefined;
  }
  
  export interface AgentDebt {
    agentDebtId?: number;
    createdDateTime?: Date;
    createdByUserId?: number;
    agentId?: number;
    companyId?: number;
    reportDate?: Date;
    advanced?: number;
    unsecured?: number;
    reserve?: number;
    side?: number;
    rollup?: number;
    producerWeek?: number;
    uplineWeek?: number;
    writingNumber?: string | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    company?: Company;
  }
  
  export interface LicensePersistency {
    licensePersistencyId?: number;
    licenseId?: number;
    licensePersistencyTypeId?: number;
    createdDateTime?: Date;
    persistencyPercentage?: number;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    licensePersistencyType?: LicensePersistencyType;
  }
  
  export interface LicensePersistencyTypeColoringRule {
    licensePersistencyTypeColoringRuleId?: number;
    licensePersistencyTypeId?: number;
    hexColor?: string | undefined;
    startRange?: number;
    stopRange?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    licensePersistencyType?: LicensePersistencyType;
  }
  
  export interface LicensePersistencyType {
    licensePersistencyTypeId?: number;
    companyId?: number;
    licensePersistencyTypeName?: string | undefined;
    sortOrder?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    licensePersistency?: LicensePersistency[] | undefined;
    licensePersistencyTypeColoringRule?:
      | LicensePersistencyTypeColoringRule[]
      | undefined;
  }
  
  export interface SubmissionRequirementRulesetFilterCompany {
    submissionRequirementRulesetFilterCompanyId?: number;
    submissionRequirementRulesetId?: number;
    companyId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByUser?: Users;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
  }
  
  export interface SubmissionRequirementRulesetFilterPolicyEffectiveDateYear {
    submissionRequirementRulesetFilterPolicyEffectiveDateYearId?: number;
    submissionRequirementRulesetId?: number;
    policyEffectiveDateYear?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
  }
  
  export interface TblProductCategory {
    id?: number;
    productCategoryName?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    tblProductSubCategory?: TblProductSubCategory[] | undefined;
  }
  
  export interface AgentProductLine {
    id?: number;
    agentId?: number;
    productLineId?: number;
    contracted?: boolean;
    active?: boolean;
    referred?: boolean;
    dateCreated?: Date;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    productLine?: TblProductLine;
  }
  
  export interface AgentContactEmailUnsubscribe {
    id?: number;
    emailId?: string | undefined;
    productLineID?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    productLine?: TblProductLine;
  }
  
  export interface TblProductLine {
    id?: number;
    productLineName?: string | undefined;
    isMarketerHierarchyBased?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentProductLine?: AgentProductLine[] | undefined;
    tblProductSubCategory?: TblProductSubCategory[] | undefined;
    agentContactEmailUnsubscribe?: AgentContactEmailUnsubscribe[] | undefined;
  }
  
  export interface SubmissionAutoUncheckRulesetFilterProductSubcategory {
    submissionAutoUncheckRulesetFilterProductSubcategoryId?: number;
    submissionAutoUncheckRulesetId?: number;
    productSubcategoryId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    productSubcategory?: TblProductSubCategory;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
  }
  
  export interface SubmissionRequirementRulesetFilterProductSubcategory {
    submissionRequirementRulesetFilterProductSubcategoryId?: number;
    submissionRequirementRulesetId?: number;
    productSubcategoryId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    productSubcategory?: TblProductSubCategory;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
  }
  
  export interface SubmissionSenderTypeEmail {
    submissionSenderTypeEmailId?: number;
    submissionSenderTypeEmailName?: string | undefined;
    fromEmailAddress?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeEmail?:
      | SubmissionRulesetConnectorTypeEmail[]
      | undefined;
  }
  
  export interface SubmissionTypeEmail {
    submissionTypeEmailId?: number;
    submissionTypeEmailName?: string | undefined;
    toEmailAddress?: string | undefined;
    sendAsSecureEmail?: boolean;
    isDisabled?: boolean;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeEmail?:
      | SubmissionRulesetConnectorTypeEmail[]
      | undefined;
  }
  
  export interface SubmissionRulesetConnectorTypeEmail {
    submissionRulesetConnectorTypeEmailId?: number;
    submissionRulesetId?: number;
    submissionTypeEmailId?: number;
    submissionSenderTypeEmailId?: number;
    fileName?: string | undefined;
    priority?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
    submissionSenderTypeEmail?: SubmissionSenderTypeEmail;
    submissionTypeEmail?: SubmissionTypeEmail;
  }
  
  export interface SubmissionTypeFtp {
    submissionTypeFtpid?: number;
    submissionTypeFtpname?: string | undefined;
    server?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    port?: number;
    ftptype?: number;
    isDisabled?: boolean;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeFtp?:
      | SubmissionRulesetConnectorTypeFtp[]
      | undefined;
  }
  
  export interface SubmissionRulesetConnectorTypeFtp {
    submissionRulesetConnectorTypeFtpid?: number;
    submissionRulesetId?: number;
    submissionTypeFtpid?: number;
    filePath?: string | undefined;
    fileName?: string | undefined;
    priority?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
    submissionTypeFtp?: SubmissionTypeFtp;
  }
  
  export interface SubmissionRulesetFilterCompany {
    submissionRulesetFilterCompanyId?: number;
    submissionRulesetId?: number;
    companyId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
  }
  
  export interface SubmissionRulesetFilterDocumentType {
    submissionRulesetFilterDocumentTypeId?: number;
    submissionRulesetId?: number;
    documentTypeId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    documentType?: FileType;
    submissionRuleset?: SubmissionRuleset;
  }
  
  export interface SubmissionRulesetFilterPolicyEffectiveDateYear {
    submissionRulesetFilterPolicyEffectiveDateYearId?: number;
    submissionRulesetId?: number;
    policyEffectiveDateYear?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
  }
  
  export interface SubmissionRulesetFilterProduct {
    submissionRulesetFilterProductId?: number;
    submissionRulesetId?: number;
    productId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    product?: TblProduct;
    submissionRuleset?: SubmissionRuleset;
  }
  
  export interface OrdersDetails {
    id?: number;
    orderId?: number;
    supplyId?: number;
    qty?: number;
    qtySent?: number | undefined;
    comment?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderDetailState?: OrderDetailState[] | undefined;
  }
  
  export interface OrderDetailState {
    orderDetailStateId?: number;
    orderDetailId?: number;
    stateId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderDetail?: OrdersDetails;
    state?: TblState;
  }
  
  export interface SubmissionAutoUncheckRulesetFilterState {
    submissionAutoUncheckRulesetFilterStateId?: number;
    submissionAutoUncheckRulesetId?: number;
    stateId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    state?: TblState;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
  }
  
  export interface SubmissionRequirementRulesetFilterState {
    submissionRequirementRulesetFilterStateId?: number;
    submissionRequirementRulesetId?: number;
    stateId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    state?: TblState;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
  }
  
  export interface LicenseNumberState {
    id?: number;
    licenseNumberId?: number;
    stateId?: number;
    state?: TblState;
  }
  
  export interface LicenseStates {
    id?: number;
    licenseId?: number;
    stateId?: number;
    apptDate?: Date | undefined;
    termDate?: Date | undefined;
    dateCreated?: Date;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    state?: TblState;
  }
  
  export interface TblProductType {
    id?: number;
    productType?: string | undefined;
    supplies?: Supplies[] | undefined;
  }
  
  export interface Supplies {
    id?: number;
    productTypeId?: number;
    companyId?: number;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    reOrderLevel?: number;
    active?: boolean | undefined;
    onOrderCount?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    productType?: TblProductType;
    suppliesStates?: SuppliesStates[] | undefined;
  }
  
  export interface SuppliesStates {
    id?: number;
    stateId?: number;
    supplyId?: number;
    notes?: string | undefined;
    reOrderLevel?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    state?: TblState;
    supply?: Supplies;
  }
  
  export interface TblState {
    id?: number;
    state?: string | undefined;
    stateName?: string | undefined;
    isTerritories?: boolean | undefined;
    orderDetailState?: OrderDetailState[] | undefined;
    submissionAutoUncheckRulesetFilterState?:
      | SubmissionAutoUncheckRulesetFilterState[]
      | undefined;
    submissionRequirementRulesetFilterState?:
      | SubmissionRequirementRulesetFilterState[]
      | undefined;
    submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
    licenseNumberState?: LicenseNumberState[] | undefined;
    licenseStates?: LicenseStates[] | undefined;
    suppliesStates?: SuppliesStates[] | undefined;
  }
  
  export interface SubmissionRulesetFilterState {
    submissionRulesetFilterStateId?: number;
    submissionRulesetId?: number;
    stateId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    state?: TblState;
    submissionRuleset?: SubmissionRuleset;
  }
  
  export interface SubmissionRuleset {
    submissionRulesetId?: number;
    submissionRulesetName?: string | undefined;
    submissionRulesetType?: number;
    priority?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeEmail?:
      | SubmissionRulesetConnectorTypeEmail[]
      | undefined;
    submissionRulesetConnectorTypeFtp?:
      | SubmissionRulesetConnectorTypeFtp[]
      | undefined;
    submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
    submissionRulesetFilterDocumentType?:
      | SubmissionRulesetFilterDocumentType[]
      | undefined;
    submissionRulesetFilterPolicyEffectiveDateYear?:
      | SubmissionRulesetFilterPolicyEffectiveDateYear[]
      | undefined;
    submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
    submissionRulesetFilterProductSubcategory?:
      | SubmissionRulesetFilterProductSubcategory[]
      | undefined;
    submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
  }
  
  export interface SubmissionRulesetFilterProductSubcategory {
    submissionRulesetFilterProductSubcategoryId?: number;
    submissionRulesetId?: number;
    productSubcategoryId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    productSubcategory?: TblProductSubCategory;
    submissionRuleset?: SubmissionRuleset;
  }
  
  export interface TblProductSubCategory {
    id?: number;
    subCategoryName?: string | undefined;
    categoryId?: number;
    isProRateable?: boolean;
    isEnrollment?: boolean;
    productClass?: string | undefined;
    productTypeCode?: string | undefined;
    productLineId?: number;
    marginFactor?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    category?: TblProductCategory;
    productLine?: TblProductLine;
    submissionAutoUncheckRulesetFilterProductSubcategory?:
      | SubmissionAutoUncheckRulesetFilterProductSubcategory[]
      | undefined;
    submissionRequirementRulesetFilterProductSubcategory?:
      | SubmissionRequirementRulesetFilterProductSubcategory[]
      | undefined;
    submissionRulesetFilterProductSubcategory?:
      | SubmissionRulesetFilterProductSubcategory[]
      | undefined;
    tblProduct?: TblProduct[] | undefined;
  }
  
  export interface SubmissionAutoUncheckRulesetFilterProduct {
    submissionAutoUncheckRulesetFilterProductId?: number;
    submissionAutoUncheckRulesetId?: number;
    productId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    product?: TblProduct;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
  }
  
  export interface Certification {
    id?: number;
    agentId?: number;
    productId?: number;
    certificationDate?: Date;
    certificationYear?: number;
    override?: boolean;
    companyId?: number;
    dateCreated?: Date;
    createdByUserId?: number;
    note?: string | undefined;
    vueExportFileDateTime?: Date | undefined;
    timestamp?: string | undefined;
    recordStatus?: boolean | undefined;
    newRecord?: boolean | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    createdByUser?: Users;
    product?: TblProduct;
  }
  
  export interface PolicyRating {
    id?: number;
    rating?: string | undefined;
    isDefault?: boolean;
    policyAppliedRating?: Policy[] | undefined;
    policyApprovedRating?: Policy[] | undefined;
  }
  
  export interface EmailType {
    id?: number;
    type?: string | undefined;
    companyContact?: CompanyContact[] | undefined;
    agentContact?: AgentContact[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
  }
  
  export interface PhoneType {
    id?: number;
    phoneTypeName?: string | undefined;
    sortOrder?: number;
    agentContact?: AgentContact[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    companyContact?: CompanyContact[] | undefined;
  }
  
  export interface AlternativePointOfContactType {
    id?: number;
    type?: string | undefined;
    companyContact?: CompanyContact[] | undefined;
    agentContact?: AgentContact[] | undefined;
  }
  
  export interface CompanyContact {
    id?: number;
    companyId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    notes?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    alternativePointOfContactTypeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    contactType?: ContactType;
    createdByUser?: Users;
    emailType?: EmailType;
    phoneType?: PhoneType;
    alternativePointOfContactType?: AlternativePointOfContactType;
  }
  
  export interface ContactType {
    id?: number;
    contactTypeName?: string | undefined;
    isHidden?: boolean;
    isHiddenForInsured?: boolean;
    agentContact?: AgentContact[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    companyContact?: CompanyContact[] | undefined;
  }
  
  export interface InsuredContact {
    id?: number;
    insuredId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    default?: boolean;
    enableSMS?: boolean;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    insured?: Customer;
    contactType?: ContactType;
    phoneType?: PhoneType;
    createdByUser?: Users;
    emailType?: EmailType;
  }
  
  export interface SubsidyLevel {
    id?: number;
    value?: string | undefined;
    customer?: Customer[] | undefined;
  }
  
  export interface AgentNoteType {
    id?: number;
    agentNoteTypeName?: string | undefined;
    agentNotes?: AgentNotes[] | undefined;
  }
  
  export interface PayoutLevelType {
    id?: number;
    type?: string | undefined;
    payoutLevel?: PayoutLevel[] | undefined;
  }
  
  export interface TblLevelMarketer {
    id?: number;
    levelId?: number;
    marketerId?: number;
    priority?: number;
    split?: number;
    dateCreated?: Date;
    vueExportFileDateTime?: Date | undefined;
    timestamp?: string | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    level?: TblLevel;
    marketer?: Agents;
  }
  
  export interface CommissionPaymentMethod {
    id?: number;
    paymentMethodName?: string | undefined;
    commPlan?: CommPlan[] | undefined;
  }
  
  export interface TblPaymentSource {
    id?: number;
    paymentSource?: string | undefined;
    commPlan?: CommPlan[] | undefined;
    profile?: Profile[] | undefined;
  }
  
  export interface RenewalAge {
    id?: number;
    planId?: number | undefined;
    age1?: number | undefined;
    age2?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    plan?: CommPlan;
  }
  
  export interface CommPlan {
    id?: number;
    companyId?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: number;
    paymentSourceId?: number;
    paymentMethodId?: number;
    alwaysShow?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    paymentMethod?: CommissionPaymentMethod;
    paymentSource?: TblPaymentSource;
    profile?: Profile[] | undefined;
    renewalAge?: RenewalAge[] | undefined;
  }
  
  export interface Profile {
    id?: number;
    commPlanId?: number;
    payToId?: number;
    mgrId?: number | undefined;
    levelId?: number;
    status?: string | undefined;
    comments?: string | undefined;
    paymentSourceId?: number;
    dateCreated?: Date;
    isActive?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    commPlan?: CommPlan;
    level?: TblLevel;
    payTo?: Agents;
    paymentSource?: TblPaymentSource;
    policy?: Policy[] | undefined;
  }
  
  export interface TblLevel {
    id?: number;
    productId?: number;
    agencyId?: number | undefined;
    licenseId?: number;
    level?: number | undefined;
    specialInstructions?: string | undefined;
    payoutLevelId?: number | undefined;
    payoutLevelDetailId?: number | undefined;
    privateInstructions?: boolean | undefined;
    dateCreated?: Date | undefined;
    sortOrder?: number | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    product?: TblProduct;
    tblLevelMarketer?: TblLevelMarketer[] | undefined;
    profile?: Profile[] | undefined;
  }
  
  export interface PayoutLevel {
    id?: number;
    companyId?: number;
    productId?: number | undefined;
    docId?: number | undefined;
    description?: string | undefined;
    internalOnly?: boolean | undefined;
    commission?: number | undefined;
    dateCreated?: Date;
    createUserId?: number;
    hidden?: boolean | undefined;
    companyRoleId?: number | undefined;
    compensationLevel?: string | undefined;
    rank?: number | undefined;
    typeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createUser?: Users;
    agentNotes?: AgentNotes[] | undefined;
    payoutLevelType?: PayoutLevelType;
    levels?: TblLevel[] | undefined;
  }
  
  export interface SalesType {
    salesTypeId?: number;
    salesTypeName?: string | undefined;
    agentNotes?: AgentNotes[] | undefined;
    license?: License[] | undefined;
  }
  
  export interface AgentNotes {
    id?: number;
    agentId?: number;
    user?: string | undefined;
    dateTime?: Date;
    note?: string | undefined;
    userId?: number;
    companyId?: number | undefined;
    payoutLevelId?: number | undefined;
    private?: boolean;
    ignore?: boolean;
    color?: number;
    agentNoteTypeId?: number;
    hierarchyPremierId?: number | undefined;
    transferFromOtherFmo?: boolean;
    salesTypeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    pinned?: boolean;
    agent?: Agents;
    agentNoteType?: AgentNoteType;
    company?: Company;
    hierarchyPremier?: Agents;
    payoutLevel?: PayoutLevel;
    salesType?: SalesType;
    userNavigation?: Users;
    title?: string | undefined;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
  }
  
  export interface DepartmentOfInsuranceLicense {
    id?: number;
    agentId?: number;
    stateId?: number;
    issueDate?: Date | undefined;
    expirationDate?: Date | undefined;
    stateLicense?: string | undefined;
    residencyStatusId?: number | undefined;
    renewalDate?: Date | undefined;
    stateLicenseStatusId?: number | undefined;
    stateLicenseActionStatusId?: number | undefined;
    notes?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    notificationSentDate?: Date | undefined;
    niprDateUpdated?: Date | undefined;
    notificationEmailAddress?: string | undefined;
    niprStatus?: string | undefined;
    niprUpdatedDate?: Date | undefined;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
  }
  
  export interface Tasks {
    id?: number;
    userId?: number;
    agentId?: number | undefined;
    customerId?: number | undefined;
    orderId?: number | undefined;
    taskDate?: Date | undefined;
    task?: string | undefined;
    description?: string | undefined;
    complete?: boolean;
    createdByUserId?: number;
    priority?: number | undefined;
    dateCreated?: Date;
    companyId?: number | undefined;
    dateCompleted?: Date | undefined;
    policyId?: number | undefined;
    completedByUserId?: number | undefined;
    modifyDate?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    policy?: Policy;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
    user?: Users;
    customer?: Customer;
    agent?: Agents;
  }
  
  export interface TblDocumentMapping {
    id?: number;
    taskId?: number | undefined;
    noteId?: number | undefined;
    stateLicenseId?: number | undefined;
    documentId?: number | undefined;
    agentId?: number | undefined;
    insuredNoteId?: number | undefined;
    note?: AgentNotes;
    stateLicense?: DepartmentOfInsuranceLicense;
    task?: Tasks;
    document?: TblDocument;
    agents?: Agents;
    insuredNote?: InsuredNote;
  }
  
  export interface InsuredNote {
    id?: number;
    customerId?: number;
    note?: string | undefined;
    title?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    private?: boolean;
    pinned?: boolean | undefined;
    deleted?: boolean | undefined;
    customer?: Customer;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
    documentMappings?: TblDocumentMapping[] | undefined;
  }
  
  export interface Customer {
    id?: number;
    lname?: string | undefined;
    fname?: string | undefined;
    mi?: string | undefined;
    suffix?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    bday?: Date;
    ssn?: string | undefined;
    encryptedSsn?: string | undefined;
    weight?: number | undefined;
    gender?: string | undefined;
    height?: string | undefined;
    spouse?: string | undefined;
    status?: string | undefined;
    notes?: string | undefined;
    hicn?: string | undefined;
    dateCreated?: Date;
    tmpSsn?: string | undefined;
    isEmployee?: boolean;
    payorName?: string | undefined;
    insuredNumber?: string | undefined;
    vueExportFileDateTime?: Date | undefined;
    timestamp?: string | undefined;
    medicareBeneficiaryIdentificationNumber?: string | undefined;
    insuredId?: number | undefined;
    countyName?: string | undefined;
    medicaidNumber?: string | undefined;
    subsidyLevelId?: number | undefined;
    statePharmaceuticalProgramMemberNumber?: string | undefined;
    dayPhone?: string | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    tblDocument?: TblDocument[] | undefined;
    policy?: Policy[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    subsidyLevel?: SubsidyLevel;
    insuredNote?: InsuredNote[] | undefined;
  }
  
  export interface Modes {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    factor?: number;
    policy?: Policy[] | undefined;
  }
  
  export interface PolicyStatus {
    id?: number;
    status?: string | undefined;
    code?: string | undefined;
    policy?: Policy[] | undefined;
  }
  
  export interface PolicyNumbers {
    policyNumberId?: number;
    policyId?: number;
    policyNumber?: string | undefined;
    createdByUserId?: number;
    createdDateTime?: Date;
    isValid?: boolean;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    policy?: Policy;
  }
  
  export interface PolicyAnnuity {
    id?: number;
    policyId?: number;
    date?: Date;
    amount?: number;
    initialDeposit?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    policy?: Policy;
  }
  
  export interface PolicyExcess {
    id?: number;
    policyId?: number;
    date?: Date;
    amount?: number;
    override?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    policy?: Policy;
  }
  
  export interface PolicyNoteType {
    id?: number;
    policyNoteTypeName?: string | undefined;
    policyNote?: PolicyNote[] | undefined;
  }
  
  export interface PolicyNote {
    id?: number;
    policyId?: number;
    userId?: number;
    noteDate?: Date;
    note?: string | undefined;
    private?: boolean;
    policyNoteTypeId?: number;
    revenueNote?: boolean | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    policy?: Policy;
    policyNoteType?: PolicyNoteType;
  }
  
  export interface PolicySingleLife {
    id?: number;
    policyId?: number;
    date?: Date;
    amount?: number;
    override?: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdBy?: number | undefined;
    policy?: Policy;
  }
  
  export interface RenewalCommissions {
    id?: number;
    agentId?: number;
    writingAgentId?: number;
    payToId?: number;
    agentName?: string | undefined;
    policyOrig?: string | undefined;
    premium?: number;
    commission?: number;
    rate?: number;
    dateCreated?: Date;
    overwrite?: boolean;
    customer?: string | undefined;
    policyTypeBase?: string | undefined;
    issueDate?: Date | undefined;
    writingAgentNumber?: string | undefined;
    advance?: string | undefined;
    refund?: string | undefined;
    duration?: number;
    paid?: boolean;
    payToName?: string | undefined;
    rateReduced?: boolean;
    datePaid?: Date | undefined;
    renewalType?: number;
    effectiveDate?: Date | undefined;
    processingCompanyId?: number;
    issueAge?: number;
    companyId?: number;
    userId?: number;
    batchId?: number | undefined;
    commissionPayFromId?: number | undefined;
    policy?: string | undefined;
    policyEffectiveDate?: Date | undefined;
    paymentSource?: string | undefined;
    flatRateAmount?: number;
    flatRateFactor?: number;
    renewalId?: number | undefined;
    policyId?: number;
    transactionId?: number | undefined;
    hidePremiumAndRate?: boolean;
    hideAllExceptAmount?: boolean;
    pdfgenerated?: boolean;
    excelGenerated?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    batch?: CommissionRunBatches;
    payTo?: Agents;
    policyNavigation?: Policy;
  }
  
  export interface Policy {
    id?: number;
    customerId?: number;
    statusId?: number;
    profileId?: number;
    mgrId?: number | undefined;
    customerAge?: number;
    premium?: number;
    cashWithApp?: number;
    mode?: number;
    commission?: number | undefined;
    pcp?: string | undefined;
    annualPremium?: number;
    dateEffective?: Date;
    datePosted?: Date | undefined;
    dateEntered?: Date;
    dateSold?: Date;
    policyFee?: number | undefined;
    agentFee?: number | undefined;
    deductible?: number;
    replaced?: boolean;
    replacedDate?: Date | undefined;
    groupName?: string | undefined;
    pendingInfo?: string | undefined;
    targetPremium?: number;
    excessPremium?: number;
    deathBenefit?: number;
    saveAge?: boolean;
    tobacco?: boolean;
    ratingId?: number | undefined;
    singleLifePremium?: number | undefined;
    advanceMonths?: number;
    dateSurrender?: Date | undefined;
    overridePercent?: number;
    dateCreated?: Date;
    commissionTypeId?: number;
    confirmationNumber?: string | undefined;
    hybridRiderId?: number | undefined;
    policyNo?: string | undefined;
    faxed?: boolean;
    ftp?: boolean;
    uploadFileName?: string | undefined;
    createdByUserId?: number;
    pendingRequirements?: boolean;
    renewalReminderNote?: string | undefined;
    faxNumberSentTo?: string | undefined;
    surrenderPeriodYears?: number;
    memberCount?: number | undefined;
    submittedOnline?: boolean;
    locationPremierId?: number | undefined;
    ssbocreditCard?: boolean;
    appliedRatingId?: number | undefined;
    approvedRatingId?: number | undefined;
    isCopy?: boolean;
    licenseNumberId?: number | undefined;
    timestamp?: string | undefined;
    originalDateEffective?: Date;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    appliedRating?: PolicyRating;
    approvedRating?: PolicyRating;
    createdByUser?: Users;
    customer?: Customer;
    locationPremier?: Agents;
    modeNavigation?: Modes;
    profile?: Profile;
    status?: PolicyStatus;
    policyNumbers?: PolicyNumbers[] | undefined;
    tblDocument?: TblDocument[] | undefined;
    policyAnnuity?: PolicyAnnuity[] | undefined;
    policyExcess?: PolicyExcess[] | undefined;
    policyNote?: PolicyNote[] | undefined;
    policySingleLife?: PolicySingleLife[] | undefined;
    renewal?: Renewal[] | undefined;
    renewalCommissions?: RenewalCommissions[] | undefined;
    tasks?: Tasks[] | undefined;
  }
  
  export interface Renewal {
    id?: number;
    payToId?: number;
    code?: string | undefined;
    firstInitial?: string | undefined;
    lastName?: string | undefined;
    policyTypeBase?: string | undefined;
    mode?: string | undefined;
    premium?: number;
    issueDate?: Date | undefined;
    conversionFlag?: string | undefined;
    advanceFlag?: string | undefined;
    endMonth?: number;
    writingAgent?: string | undefined;
    company?: number | undefined;
    commPlanId?: number | undefined;
    renewalIssueAge?: number;
    renewalComplete?: boolean;
    productId?: number | undefined;
    policyId?: number | undefined;
    renewalType?: number | undefined;
    createDate?: Date | undefined;
    userId?: number | undefined;
    dateCreated?: Date | undefined;
    policy?: string | undefined;
    paymentSource?: string | undefined;
    flatRateFactor?: number | undefined;
    premiumOverride?: number | undefined;
    batchId?: number | undefined;
    rowVersion?: string | undefined;
    isProcessed?: boolean;
    statementDate?: Date | undefined;
    commissionReceived?: number | undefined;
    commissionPayable?: number | undefined;
    payeesOnPlan?: number | undefined;
    commissionPlanPayees?: string | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    batch?: CommissionRunBatches;
    policyNavigation?: Policy;
  }
  
  export interface CommissionRunBatches {
    id?: number;
    batchName?: string | undefined;
    payDate?: Date;
    userId?: number;
    divisionId?: number;
    approved?: boolean;
    paid?: boolean;
    pdfgenerated?: boolean;
    excelGenerated?: boolean;
    companyId?: number | undefined;
    totalCount?: number | undefined;
    processedCount?: number | undefined;
    failedCount?: number | undefined;
    notificationSent?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    division?: Division;
    user?: Users;
    renewal?: Renewal[] | undefined;
    renewalCommissions?: RenewalCommissions[] | undefined;
  }
  
  export interface MarketingUnsubscribe {
    id?: number;
    agentId?: number | undefined;
    divisionId?: number;
    emailAddress?: string | undefined;
    dateCreated?: Date;
    marketingEventId?: number | undefined;
    division?: Division;
  }
  
  export interface CompanyAddresses {
    id?: number;
    companyId?: number;
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    zipCode?: string | undefined;
    cityName?: string | undefined;
    stateAbbreviation?: string | undefined;
    countyName?: string | undefined;
    addressType?: number;
    dateCreated?: Date;
    userId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    addressTypeNavigation?: TblAddressType;
    company?: Company;
    user?: Users;
  }
  
  export interface TblAddressType {
    id?: number;
    addressType?: string | undefined;
    isHidden?: boolean;
    isHiddenForCarrier?: boolean;
    addresses?: Addresses[] | undefined;
    companyAddresses?: CompanyAddresses[] | undefined;
  }
  
  export interface AgentToAddress {
    agentId?: number;
    addressId?: number;
    address?: Addresses;
    agent?: Agents;
  }
  
  export interface Addresses {
    id?: number;
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    lastLine?: string | undefined;
    zipCode?: string | undefined;
    addressee?: string | undefined;
    firmName?: string | undefined;
    deliveryPointBarcode?: string | undefined;
    visibleInUpline?: boolean;
    visibleInDownline?: boolean;
    securityAccessCode?: string | undefined;
    addressType?: number | undefined;
    visible?: boolean;
    dateCreated?: Date;
    userId?: number;
    urbanization?: string | undefined;
    primaryNumber?: string | undefined;
    streetName?: string | undefined;
    streetPredirection?: string | undefined;
    streetPostdirection?: string | undefined;
    streetSuffix?: string | undefined;
    secondaryNumber?: string | undefined;
    secondaryDesignator?: string | undefined;
    extraSecondaryNumber?: string | undefined;
    extraSecondaryDesignator?: string | undefined;
    pmbDesignator?: string | undefined;
    pmbNumber?: string | undefined;
    cityName?: string | undefined;
    defaultCityName?: string | undefined;
    stateAbbreviation?: string | undefined;
    plusFourCode?: string | undefined;
    deliveryPoint?: string | undefined;
    deliveryPointCheckDigit?: string | undefined;
    recordType?: string | undefined;
    zipType?: string | undefined;
    countyFips?: string | undefined;
    countyName?: string | undefined;
    carrierRoute?: string | undefined;
    congressionalDistrict?: string | undefined;
    buildingDefaultIndicator?: string | undefined;
    rdi?: string | undefined;
    elotSequence?: string | undefined;
    elotSort?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    precision?: string | undefined;
    dpvCmra?: string | undefined;
    dpvVacant?: string | undefined;
    active?: string | undefined;
    ewsMatch?: string | undefined;
    footnotes?: string | undefined;
    lacslinkCode?: string | undefined;
    lacslinkIndicator?: string | undefined;
    suitelinkMatch?: string | undefined;
    dpvMatchCode?: string | undefined;
    dpvFootnotes?: string | undefined;
    addressComments?: string | undefined;
    isValid?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    addressTypeNavigation?: TblAddressType;
    agentToAddress?: AgentToAddress[] | undefined;
    orders?: Orders[] | undefined;
  }
  
  export interface ShippingMethod {
    id?: number;
    method?: string | undefined;
    orders?: Orders[] | undefined;
  }
  
  export interface Orders {
    id?: number;
    agentId?: number;
    userId?: number;
    shippingMethodId?: number | undefined;
    orderTakenByUserId?: number;
    orderDate?: Date;
    comments?: string | undefined;
    completed?: boolean;
    addressId?: number;
    completedDate?: Date | undefined;
    trackingNumber?: string | undefined;
    weight?: number | undefined;
    shippingDate?: Date | undefined;
    fee?: number | undefined;
    departmentId?: number | undefined;
    printedDate?: Date | undefined;
    divisionId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    address?: Addresses;
    division?: Division;
    orderTakenByUser?: Users;
    shippingMethod?: ShippingMethod;
  }
  
  export interface Revenue {
    id?: number;
    companyId?: number;
    paidDivisionId?: number;
    statementDate?: Date;
    amount?: number;
    comment?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    paidDivision?: Division;
  }
  
  export interface Division {
    id?: number;
    divisionName?: string | undefined;
    divisionGroupId?: number | undefined;
    abbreviation?: string | undefined;
    commissionRunBatches?: CommissionRunBatches[] | undefined;
    marketingUnsubscribe?: MarketingUnsubscribe[] | undefined;
    orders?: Orders[] | undefined;
    revenue?: Revenue[] | undefined;
    userTeam?: UserTeam[] | undefined;
  }
  
  export interface UserManageTeam {
    id?: number;
    userId?: number;
    teamId?: number;
    team?: UserTeam;
    user?: Users;
  }
  
  export interface UserTeamAgencyId {
    id?: number;
    teamId?: number;
    premierId?: number;
    premier?: Agents;
    team?: UserTeam;
  }
  
  export interface UserTeam {
    id?: number;
    divisionId?: number;
    teamName?: string | undefined;
    includeInReport?: boolean;
    includeInWorkflow?: boolean;
    allowAccesstoPasswordList?: boolean | undefined;
    marketerId?: number | undefined;
    phoneExtension?: number | undefined;
    color?: number;
    managerId?: number | undefined;
    reportColor?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    division?: Division;
    marketer?: Agents;
    tblDocument?: TblDocument[] | undefined;
    userManageTeam?: UserManageTeam[] | undefined;
    userTeamAgencyId?: UserTeamAgencyId[] | undefined;
  }
  
  export interface WorkflowProcessLog {
    id?: number;
    masterDocId?: number;
    workflowStatusId?: number;
    userId?: number;
    dateTimeOfAction?: Date;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    masterDoc?: TblDocument;
    user?: Users;
    workflowStatus?: TblDocumentWorkflowStatus;
  }
  
  export interface TblDocumentWorkflowStatus {
    id?: number;
    workflowStatus?: string | undefined;
    path?: string | undefined;
    displayInWorkflowKpis?: boolean | undefined;
    tblDocument?: TblDocument[] | undefined;
    workflowProcessLog?: WorkflowProcessLog[] | undefined;
  }
  
  export interface TblDocument {
    id?: number;
    date?: Date | undefined;
    ssn?: string | undefined;
    path?: string | undefined;
    filename?: string | undefined;
    fileType?: number | undefined;
    notes?: string | undefined;
    committed?: boolean;
    lname?: string | undefined;
    fname?: string | undefined;
    policyNo?: string | undefined;
    volume?: string | undefined;
    agentId?: number | undefined;
    customerId?: number | undefined;
    paperport?: boolean;
    updated?: boolean;
    typeId?: number;
    companyId?: number | undefined;
    upload?: boolean | undefined;
    uploaded?: boolean;
    policyId?: number | undefined;
    licenseId?: number | undefined;
    createdBy?: number;
    createdDate?: Date;
    workflowStatusId?: number;
    assignedToUserId?: number | undefined;
    masterDocId?: number | undefined;
    ownerId?: number | undefined;
    appDate?: Date | undefined;
    private?: boolean;
    productId?: number | undefined;
    assignedToTeamId?: number | undefined;
    changeForm?: boolean;
    flag?: string | undefined;
    compressed?: boolean;
    file512Hash?: string | undefined;
    errorCount?: number;
    submissionReceived?: boolean;
    missingInfoComment?: string | undefined;
    guid?: string | undefined;
    synced?: boolean | undefined;
    insuredNumber?: string | undefined;
    agentCode?: string | undefined;
    pendingCertificates?: boolean | undefined;
    extension?: string | undefined;
    rowVersion?: string | undefined;
    uplineAgentId?: number | undefined;
    marketerAgentId?: number | undefined;
    submitToOption?: number | undefined;
    submitToValue?: string | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    assignedToTeam?: UserTeam;
    company?: Company;
    customer?: Customer;
    marketerAgent?: Agents;
    masterDoc?: TblDocument;
    policy?: Policy;
    product?: TblProduct;
    type?: FileType;
    uplineAgent?: Agents;
    workflowStatus?: TblDocumentWorkflowStatus;
    inverseMasterDoc?: TblDocument[] | undefined;
    workflowProcessLog?: WorkflowProcessLog[] | undefined;
    documentMapping?: TblDocumentMapping[] | undefined;
  }
  
  export interface TblProduct {
    id?: number;
    prodNum?: string | undefined;
    companyId?: number;
    product?: string | undefined;
    typeId?: number;
    age1?: number;
    level1?: number;
    age2?: number;
    level2?: number;
    age3?: number;
    level3?: number;
    age4?: number;
    level4?: number;
    age5?: number;
    level5?: number;
    age6?: number;
    level6?: number;
    age7?: number;
    level7?: number;
    age8?: number;
    level8?: number;
    age9?: number;
    level9?: number;
    age10?: number;
    level10?: number;
    policyFee?: number;
    agentFee?: number;
    rider?: boolean;
    tripCategoryId?: number;
    hidden?: boolean;
    subCategory?: string | undefined;
    payoutLevelId?: number | undefined;
    productTypeId?: number;
    productCategoryId?: number;
    defaultPremium?: number;
    defaultMode?: number;
    importDefaultPremium?: number;
    importDefaultMode?: number;
    subCategoryId?: number;
    carrierProductName?: string | undefined;
    fraudWatch?: boolean;
    divisionId?: number;
    dateCreated?: Date;
    checkForCertification?: boolean;
    checkForAppointment?: boolean;
    productClassId?: number | undefined;
    productCode?: string | undefined;
    isAppointmentAndCertificationRequired?: boolean;
    isShowPremiumInCommissionReportStatement?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    subCategoryNavigation?: TblProductSubCategory;
    submissionAutoUncheckRulesetFilterProduct?:
      | SubmissionAutoUncheckRulesetFilterProduct[]
      | undefined;
    submissionRequirementRulesetFilterProduct?:
      | SubmissionRequirementRulesetFilterProduct[]
      | undefined;
    submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
    certification?: Certification[] | undefined;
    tblDocument?: TblDocument[] | undefined;
    tblLevel?: TblLevel[] | undefined;
  }
  
  export interface SubmissionRequirementRulesetFilterProduct {
    submissionRequirementRulesetFilterProductId?: number;
    submissionRequirementRulesetId?: number;
    productId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    product?: TblProduct;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
  }
  
  export interface SubmissionRequirementRuleset {
    submissionRequirementRulesetId?: number;
    submissionRequirementRulesetName?: string | undefined;
    submissionRulesetType?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRequirementRulesetFilterCompany?:
      | SubmissionRequirementRulesetFilterCompany[]
      | undefined;
    submissionRequirementRulesetFilterDocumentType?:
      | SubmissionRequirementRulesetFilterDocumentType[]
      | undefined;
    submissionRequirementRulesetFilterPolicyEffectiveDateYear?:
      | SubmissionRequirementRulesetFilterPolicyEffectiveDateYear[]
      | undefined;
    submissionRequirementRulesetFilterProduct?:
      | SubmissionRequirementRulesetFilterProduct[]
      | undefined;
    submissionRequirementRulesetFilterProductSubcategory?:
      | SubmissionRequirementRulesetFilterProductSubcategory[]
      | undefined;
    submissionRequirementRulesetFilterState?:
      | SubmissionRequirementRulesetFilterState[]
      | undefined;
  }
  
  export interface SubmissionRequirementRulesetFilterDocumentType {
    submissionRequirementRulesetFilterDocumentTypeId?: number;
    submissionRequirementRulesetId?: number;
    documentTypeId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    documentType?: FileType;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
  }
  
  export interface FileType {
    id?: number;
    type?: string | undefined;
    isHierarchyRequired?: boolean;
    isInsured?: boolean;
    submissionAutoUncheckRulesetFilterDocumentType?:
      | SubmissionAutoUncheckRulesetFilterDocumentType[]
      | undefined;
    submissionRequirementRulesetFilterDocumentType?:
      | SubmissionRequirementRulesetFilterDocumentType[]
      | undefined;
    submissionRulesetFilterDocumentType?:
      | SubmissionRulesetFilterDocumentType[]
      | undefined;
    tblDocument?: TblDocument[] | undefined;
  }
  
  export interface SubmissionAutoUncheckRulesetFilterDocumentType {
    submissionAutoUncheckRulesetFilterDocumentTypeId?: number;
    submissionAutoUncheckRulesetId?: number;
    documentTypeId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    documentType?: FileType;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
  }
  
  export interface SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear {
    submissionAutoUncheckRulesetFilterPolicyEffectiveDateYearId?: number;
    submissionAutoUncheckRulesetId?: number;
    policyEffectiveDateYear?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
  }
  
  export interface SubmissionAutoUncheckRuleset {
    submissionAutoUncheckRulesetId?: number;
    submissionAutoUncheckRulesetName?: string | undefined;
    submissionRulesetType?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionAutoUncheckRulesetFilterCompany?:
      | SubmissionAutoUncheckRulesetFilterCompany[]
      | undefined;
    submissionAutoUncheckRulesetFilterDocumentType?:
      | SubmissionAutoUncheckRulesetFilterDocumentType[]
      | undefined;
    submissionAutoUncheckRulesetFilterPolicyEffectiveDateYear?:
      | SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear[]
      | undefined;
    submissionAutoUncheckRulesetFilterProduct?:
      | SubmissionAutoUncheckRulesetFilterProduct[]
      | undefined;
    submissionAutoUncheckRulesetFilterProductSubcategory?:
      | SubmissionAutoUncheckRulesetFilterProductSubcategory[]
      | undefined;
    submissionAutoUncheckRulesetFilterState?:
      | SubmissionAutoUncheckRulesetFilterState[]
      | undefined;
  }
  
  export interface SubmissionAutoUncheckRulesetFilterCompany {
    submissionAutoUncheckRulesetFilterCompanyId?: number;
    submissionAutoUncheckRulesetId?: number;
    companyId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByUser?: Users;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
  }
  
  export interface Appointment {
    id?: number;
    agentId?: number;
    companyId?: number;
    effectiveDate?: Date;
    state?: string | undefined;
    appointmentNote?: string | undefined;
    recordStatus?: boolean | undefined;
    newRecord?: boolean | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    company?: Company;
  }
  
  export interface CompanyNote {
    id?: number;
    companyId?: number;
    title?: string | undefined;
    note?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
  }
  
  export interface Company {
    id?: number;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    url?: string | undefined;
    email?: string | undefined;
    networkShare?: string | undefined;
    createDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    defaultPaymentSourceId?: number | undefined;
    abbreviation?: string | undefined;
    marketerRenewalSpecialProcessing?: boolean;
    proRateFirstYearCommissions?: boolean;
    hidden?: boolean;
    commissionProcessingDivisionId?: number;
    isSourceOfTruth?: boolean | undefined;
    isExportable?: boolean;
    carrierShortName?: string | undefined;
    premierLegalEntityLicenseId?: number | undefined;
    carrierGroupName?: string | undefined;
    isArchived?: boolean;
    premierLegalEntityAgentId?: number | undefined;
    canArrangementDifferByState?: boolean;
    canArrangementDifferByProductType?: boolean;
    canMarketerDifferByProductType?: boolean;
    canSendContractArrangementMarketer?: boolean;
    canSendCrossReference?: boolean;
    canSendPolicyLevelRate?: boolean;
    canVerifyDataIntegrity?: boolean;
    canArrangementReportToShareSameCompanyRole?: boolean;
    releaseGroupName?: string | undefined;
    plrandNewBusinessSeparationDate?: Date | undefined;
    isEligiblityRequired?: boolean;
    allowOverlappingDates?: boolean | undefined;
    carrierGroupId?: number | undefined;
    strictContracting?: boolean;
    masterCarrierId?: string;
    agentDebt?: AgentDebt[] | undefined;
    licensePersistencyType?: LicensePersistencyType[] | undefined;
    submissionAutoUncheckRulesetFilterCompany?:
      | SubmissionAutoUncheckRulesetFilterCompany[]
      | undefined;
    submissionRequirementRulesetFilterCompany?:
      | SubmissionRequirementRulesetFilterCompany[]
      | undefined;
    submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
    agentNotes?: AgentNotes[] | undefined;
    appointment?: Appointment[] | undefined;
    tblDocument?: TblDocument[] | undefined;
    license?: License[] | undefined;
    tasks?: Tasks[] | undefined;
    companyContact?: CompanyContact[] | undefined;
    companyAddresses?: CompanyAddresses[] | undefined;
    companyNotes?: CompanyNote[] | undefined;
  }
  
  export interface LicenseAdvanceOption {
    licenseAdvanceOptionId?: number;
    licenseAdvanceOptionName?: string | undefined;
    license?: License[] | undefined;
  }
  
  export interface LicenseStatusReason {
    id?: number;
    reason?: string | undefined;
    statusId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    status?: LicenseStatus;
    license?: License[] | undefined;
  }
  
  export interface LicenseStatus {
    id?: number;
    status?: string | undefined;
    isActiveStatus?: boolean;
    licenseStatusReason?: LicenseStatusReason[] | undefined;
    license?: License[] | undefined;
  }
  
  export interface LicensePrincipalAgents {
    id?: number;
    licenseId?: number;
    principalAgentId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    principalAgent?: Agents;
  }
  
  export interface CompanyLicenseNumberDefaults {
    id?: number;
    companyId?: number;
    licenseNumberTypeId?: number;
    isWritableDefault?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    licenseNumberType?: LicenseNumberType;
  }
  
  export interface LicenseNumberType {
    id?: number;
    licenseNumberTypeName?: string | undefined;
    companyLicenseNumberDefaults?: CompanyLicenseNumberDefaults[] | undefined;
    licenseNumber?: LicenseNumber[] | undefined;
  }
  
  export interface LicenseNumber {
    id?: number;
    licenseId?: number;
    number?: string | undefined;
    licenseNumberTypeId?: number;
    isWritable?: boolean;
    crossReferenceId?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    licenseNumberType?: LicenseNumberType;
  }
  
  export interface LicenseAdvanced {
    id?: number;
    advanced?: string | undefined;
    sortOrder?: number;
    license?: License[] | undefined;
  }
  
  export interface LicenseAppointmentType {
    id?: number;
    type?: string | undefined;
    license?: License[] | undefined;
  }
  
  export interface LicenseNotes {
    id?: number;
    licenseId?: number;
    note?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
    rowVersion?: string | undefined;
  }
  
  export interface LicenseLocation {
    id?: number;
    licenseId?: number;
    locationId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    location?: Agents;
  }
  
  export interface License {
    id?: number;
    agentId?: number;
    companyId?: number;
    statusId?: number;
    apptDate?: Date;
    termDate?: Date | undefined;
    submittedDate?: Date | undefined;
    agentNumber?: string | undefined;
    agencyNumber?: string | undefined;
    notes?: string | undefined;
    compNumber?: string | undefined;
    dateCreated?: Date;
    reportsToAgentId?: number;
    reportsToLicenseId?: number | undefined;
    userId?: number;
    underConstruction?: boolean | undefined;
    doNotCall?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmail?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarket?: boolean;
    doNotMarketDownlineDefault?: boolean;
    colorDownlineWhenImporting?: number | undefined;
    bankAccountId?: number | undefined;
    agencyIsPayee?: boolean;
    timestamp?: string | undefined;
    payeeId?: number | undefined;
    statusReasonId?: number | undefined;
    statusReasonUpdatedDate?: Date;
    licenseAdvanceOptionId?: number | undefined;
    maxAdvanceAmount?: number;
    salesTypeId?: number;
    licenseAdvancedId?: number | undefined;
    processedBy?: number | undefined;
    contractReceiptDate?: Date | undefined;
    approvalDate?: Date | undefined;
    appSubmittedWithin90Days?: Date | undefined;
    appointmentType?: number | undefined;
    agentGroupId?: number | undefined;
    onlyShowActiveAndPending?: boolean | undefined;
    replacedFromLicenseId?: number | undefined;
    replacedByLicenseId?: number | undefined;
    advance_Months?: number;
    createdBy?: number | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    bankAccount?: BankAccounts;
    company?: Company;
    licenseAdvanceOption?: LicenseAdvanceOption;
    payee?: Agents;
    salesType?: SalesType;
    status?: LicenseStatus;
    statusReason?: LicenseStatusReason;
    user?: Users;
    licensePersistency?: LicensePersistency[] | undefined;
    licensePrincipalAgents?: LicensePrincipalAgents[] | undefined;
    tblLevel?: TblLevel[] | undefined;
    licenseNumber?: LicenseNumber[] | undefined;
    licenseStates?: LicenseStates[] | undefined;
    licenseAdvanced?: LicenseAdvanced;
    users?: Users;
    licenseAppointmentType?: LicenseAppointmentType;
    licenseNotes?: LicenseNotes[] | undefined;
    licenseCommunications?: LicenseCommunication[] | undefined;
    licenseLocations?: LicenseLocation[] | undefined;
  }
  
  export interface BankAccounts {
    bankAccountId?: number;
    agentId?: number;
    bankId?: number | undefined;
    accountNumber?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    bankAccountTypeId?: number | undefined;
    bankAccountPaymentMethodId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    bank?: Bank;
    bankAccountPaymentMethod?: BankAccountPaymentMethod;
    bankAccountType?: BankAccountType;
    createdByUser?: Users;
    license?: License[] | undefined;
  }
  
  export interface PayoutLevelDetails {
    id?: number;
    payoutLevelId?: number;
    productId?: number;
    description?: string | undefined;
    commission?: number;
    dateCreated?: Date;
    createUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createUser?: Users;
  }
  
  export interface AgentAlert {
    id?: number;
    alert?: string | undefined;
    agentId?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    agent?: Agents;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
  }
  
  export interface ProviderUser {
    providerUserId?: number;
    identityUserId?: string | undefined;
    provider?: string | undefined;
    userId?: number;
    user?: Users;
  }
  
  export interface FederalTaxClassification {
    id?: number;
    classification?: string | undefined;
    taxpayerIdentification?: TaxpayerIdentification[] | undefined;
  }
  
  export interface TaxpayerIdentification {
    taxpayerId?: number;
    name?: string | undefined;
    businessName?: string | undefined;
    ein?: string | undefined;
    ssn?: string | undefined;
    addressId?: number;
    federalTaxClassificationId?: number;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    federalTaxClassification?: FederalTaxClassification;
    modifiedByNavigation?: Users;
    agents?: Agents[] | undefined;
  }
  
  export interface Users {
    id?: number;
    loginName?: string | undefined;
    first?: string | undefined;
    last?: string | undefined;
    secLevel?: number;
    password?: string | undefined;
    email?: string | undefined;
    userId?: number | undefined;
    extension?: number | undefined;
    teamId?: number;
    marketerId?: number | undefined;
    active?: boolean | undefined;
    newSystemOnly?: boolean | undefined;
    agencyId?: string | undefined;
    workflowEmail?: boolean;
    workflowTasks?: boolean;
    hostedEmailPassword?: string | undefined;
    ciscoUserName?: string | undefined;
    ciscoPassword?: string | undefined;
    domainName?: string | undefined;
    phoneType?: number;
    maxLeadCount?: number;
    clearBrowserCache?: boolean;
    impersonatedUserId?: number | undefined;
    managingTeamId?: number | undefined;
    phoneDeviceId?: string | undefined;
    dateCreated?: Date;
    leadCallListId?: number | undefined;
    adguid?: string | undefined;
    isAdsyncable?: boolean | undefined;
    userProperties?: string | undefined;
    contractGridColProperties?: string | undefined;
    isDownlineAgency?: boolean;
    downlineAgencyId?: number | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    leadCallList?: Calllist;
    marketer?: Agents;
    bankAccounts?: BankAccounts[] | undefined;
    policyNumbers?: PolicyNumbers[] | undefined;
    submissionAutoUncheckRulesetCreatedByUser?:
      | SubmissionAutoUncheckRuleset[]
      | undefined;
    submissionAutoUncheckRulesetFilterCompany?:
      | SubmissionAutoUncheckRulesetFilterCompany[]
      | undefined;
    submissionAutoUncheckRulesetFilterDocumentType?:
      | SubmissionAutoUncheckRulesetFilterDocumentType[]
      | undefined;
    submissionAutoUncheckRulesetFilterPolicyEffectiveDateYear?:
      | SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear[]
      | undefined;
    submissionAutoUncheckRulesetFilterProduct?:
      | SubmissionAutoUncheckRulesetFilterProduct[]
      | undefined;
    submissionAutoUncheckRulesetFilterProductSubcategory?:
      | SubmissionAutoUncheckRulesetFilterProductSubcategory[]
      | undefined;
    submissionAutoUncheckRulesetFilterState?:
      | SubmissionAutoUncheckRulesetFilterState[]
      | undefined;
    submissionAutoUncheckRulesetModifiedByUser?:
      | SubmissionAutoUncheckRuleset[]
      | undefined;
    submissionRequirementRulesetCreatedByUser?:
      | SubmissionRequirementRuleset[]
      | undefined;
    submissionRequirementRulesetFilterCompany?:
      | SubmissionRequirementRulesetFilterCompany[]
      | undefined;
    submissionRequirementRulesetFilterDocumentType?:
      | SubmissionRequirementRulesetFilterDocumentType[]
      | undefined;
    submissionRequirementRulesetFilterPolicyEffectiveDateYear?:
      | SubmissionRequirementRulesetFilterPolicyEffectiveDateYear[]
      | undefined;
    submissionRequirementRulesetFilterProduct?:
      | SubmissionRequirementRulesetFilterProduct[]
      | undefined;
    submissionRequirementRulesetFilterProductSubcategory?:
      | SubmissionRequirementRulesetFilterProductSubcategory[]
      | undefined;
    submissionRequirementRulesetFilterState?:
      | SubmissionRequirementRulesetFilterState[]
      | undefined;
    submissionRequirementRulesetModifiedByUser?:
      | SubmissionRequirementRuleset[]
      | undefined;
    submissionRulesetConnectorTypeEmailCreatedByUser?:
      | SubmissionRulesetConnectorTypeEmail[]
      | undefined;
    submissionRulesetConnectorTypeEmailModifiedByUser?:
      | SubmissionRulesetConnectorTypeEmail[]
      | undefined;
    submissionRulesetConnectorTypeFtpCreatedByUser?:
      | SubmissionRulesetConnectorTypeFtp[]
      | undefined;
    submissionRulesetConnectorTypeFtpModifiedByUser?:
      | SubmissionRulesetConnectorTypeFtp[]
      | undefined;
    submissionRulesetCreatedByUser?: SubmissionRuleset[] | undefined;
    submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
    submissionRulesetFilterDocumentType?:
      | SubmissionRulesetFilterDocumentType[]
      | undefined;
    submissionRulesetFilterPolicyEffectiveDateYear?:
      | SubmissionRulesetFilterPolicyEffectiveDateYear[]
      | undefined;
    submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
    submissionRulesetFilterProductSubcategory?:
      | SubmissionRulesetFilterProductSubcategory[]
      | undefined;
    submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
    submissionRulesetModifiedByUser?: SubmissionRuleset[] | undefined;
    submissionSenderTypeEmailCreatedByUser?:
      | SubmissionSenderTypeEmail[]
      | undefined;
    submissionSenderTypeEmailModifiedByUser?:
      | SubmissionSenderTypeEmail[]
      | undefined;
    submissionTypeEmailCreatedByUser?: SubmissionTypeEmail[] | undefined;
    submissionTypeEmailModifiedByUser?: SubmissionTypeEmail[] | undefined;
    submissionTypeFtpCreatedByUser?: SubmissionTypeFtp[] | undefined;
    submissionTypeFtpModifiedByUser?: SubmissionTypeFtp[] | undefined;
    agentContact?: AgentContact[] | undefined;
    agentNotes?: AgentNotes[] | undefined;
    agentsCreatedByNavigation?: Agents[] | undefined;
    agentsProfileUpdatedByUser?: Agents[] | undefined;
    agentsUser?: Agents[] | undefined;
    certification?: Certification[] | undefined;
    commissionRunBatches?: CommissionRunBatches[] | undefined;
    license?: License[] | undefined;
    orders?: Orders[] | undefined;
    payoutLevel?: PayoutLevel[] | undefined;
    payoutLevelDetails?: PayoutLevelDetails[] | undefined;
    policy?: Policy[] | undefined;
    userManageTeam?: UserManageTeam[] | undefined;
    workflowProcessLog?: WorkflowProcessLog[] | undefined;
    licenseProcessedBy?: License[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    companyContact?: CompanyContact[] | undefined;
    companyCreateUsers?: Company[] | undefined;
    companyModifyUsers?: Company[] | undefined;
    companyAddresses?: CompanyAddresses[] | undefined;
    companyNoteCreatedByNavigations?: CompanyNote[] | undefined;
    companyNoteModifiedByNavigations?: CompanyNote[] | undefined;
    agentAlertCreatedByNavigations?: AgentAlert[] | undefined;
    agentAlertModifiedByNavigations?: AgentAlert[] | undefined;
    providerUser?: ProviderUser;
    taxpayerIdentification?: TaxpayerIdentification[] | undefined;
    insuredNoteCreatedByNavigations?: InsuredNote[] | undefined;
    insuredNoteModifiedByNavigations?: InsuredNote[] | undefined;
    licenseNoteCreatedByNavigations?: LicenseNotes[] | undefined;
    licenseNoteModifiedByNavigations?: LicenseNotes[] | undefined;
  }
  
  export interface AgentHierarchyLevel {
    id?: number;
    name?: string | undefined;
    agents?: Agents[] | undefined;
  }
  
  export interface TblStatus {
    id?: number;
    status?: string | undefined;
    message?: string | undefined;
    agents?: Agents[] | undefined;
  }
  
  export interface AgentLeadSource {
    agentLeadSourceId?: number;
    agentLeadSourceName?: string | undefined;
    leadMustBeReferrable?: boolean;
    agentLead?: AgentLead[] | undefined;
  }
  
  export interface AgentLeadMeta {
    agentLeadId?: number;
    leadName?: string | undefined;
    leadFirstName?: string | undefined;
    leadLastName?: string | undefined;
    alternativeContactName?: string | undefined;
    recruiterName?: string | undefined;
    businessUnit?: string | undefined;
    leadNpn?: string | undefined;
    leadSource?: string | undefined;
    leadSourceDetail?: string | undefined;
    unverifiedLeadEmails?: string | undefined;
    unverifiedLeadPhoneNumbers?: string | undefined;
    verifiedLeadEmails?: string | undefined;
    verifiedLeadPhoneNumbers?: string | undefined;
    targetCarrier?: string | undefined;
    leadNote?: string | undefined;
    invalidReferral?: boolean;
    productContracted?: string | undefined;
    recruiterEmail?: string | undefined;
    recruiterPhone?: string | undefined;
    isClosed?: boolean;
    isPreContracted?: boolean;
    isContractingSent?: boolean;
    isContracted?: boolean;
    hasPolicies?: boolean;
    productLineActivated?: boolean;
    sharepointId?: number | undefined;
    invalidForActivation?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentLead?: AgentLead;
  }
  
  export interface AgentLeadPhase {
    id?: number;
    leadPhaseName?: string | undefined;
  }
  
  export interface AgentLeadPhaseDetail {
    id?: number;
    leadPhaseId?: number;
    leadPhaseDetailName?: string | undefined;
    isLeadPhaseDefault?: boolean;
  }
  
  export interface AgentLead {
    agentLeadId?: number;
    productLineId?: number | undefined;
    agentId?: number | undefined;
    assigneeId?: number | undefined;
    assignerId?: number | undefined;
    carrierId?: number | undefined;
    leadPhaseId?: number;
    leadPhaseDetailId?: number;
    dateCreated?: Date;
    dateAssigned?: Date | undefined;
    agentLeadSourceId?: number;
    agentLeadSourceDetailId?: number | undefined;
    dateFollowUp?: Date | undefined;
    subAssigneeId?: number | undefined;
    createdUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    agentLeadSource?: AgentLeadSource;
    agentLeadMeta?: AgentLeadMeta;
    assignee?: Users;
    subAssignee?: Users;
    leadPhase?: AgentLeadPhase;
    productLine?: AgentProductLine;
    carrier?: Company;
    leadPhaseDetail?: AgentLeadPhaseDetail;
  }
  
  export interface AgentMarketers {
    agentMarketerId?: number;
    agentId?: number;
    marketerId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    marketer?: Agents;
  }
  
  export interface AgentPortalPassword {
    agentPortalPasswordId?: number;
    agentId?: number;
    password?: string | undefined;
    salt?: string | undefined;
    dateCreated?: Date;
    agent?: Agents;
  }
  
  export interface AgentPortalPasswordReset {
    agentPortalPasswordResetId?: number;
    agentId?: number;
    resetCode?: string | undefined;
    expiresDateTime?: Date;
    isUsed?: boolean;
    dateCreated?: Date;
    agent?: Agents;
  }
  
  export interface AgentPrincipalAgents {
    id?: number;
    agentId?: number;
    principalAgentId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    principalAgent?: Agents;
  }
  
  export interface AgentToPayee {
    id?: number;
    agentId?: number;
    payeeId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    payee?: Agents;
  }
  
  export interface RenewalRates {
    id?: number;
    agentId?: number;
    ageId?: number;
    payToId?: number;
    month1?: number;
    month2?: number;
    rate?: number;
    flatRate?: boolean;
    flatRateAmount?: number;
    payFromProfit?: number;
    payFromId?: number;
    hidePremiumAndRate?: boolean;
    hideAllExceptAmount?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    payTo?: Agents;
  }
  
  export interface AppUserRole {
    id?: number;
    userRoleName?: string | undefined;
    isDownlineRole?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    appUserRoleDownlineAgencies?: AppUserRoleDownlineAgency[] | undefined;
  }
  
  export interface AppUserRoleDownlineAgency {
    id?: number;
    appUserRoleId?: number;
    agencyId?: number;
    userId?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agency?: Agents;
    appUserRole?: AppUserRole;
  }
  
  export interface Agents {
    id?: number;
    lastName?: string | undefined;
    middle?: string | undefined;
    firstName?: string | undefined;
    nickname?: string | undefined;
    suffix?: string | undefined;
    status?: number | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    state?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    source?: number;
    lhrId?: number | undefined;
    agency?: string | undefined;
    dob?: Date | undefined;
    ssn?: string | undefined;
    encryptedSsn?: string | undefined;
    tin?: string | undefined;
    spouse?: string | undefined;
    terminatedOption?: number | undefined;
    dba?: string | undefined;
    smrId?: number | undefined;
    ratingId?: number | undefined;
    marketer?: boolean;
    timestamp?: string | undefined;
    healthRating?: string | undefined;
    lifeRating?: string | undefined;
    annuityRating?: string | undefined;
    finalExpenseRating?: string | undefined;
    userId?: number | undefined;
    password?: string | undefined;
    healthRatingLocked?: boolean;
    ltcrating?: string | undefined;
    website?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number;
    designation?: string | undefined;
    enableLogin?: boolean;
    hasDebt?: boolean;
    profileUpdatedByUserId?: number | undefined;
    npn?: string | undefined;
    defaultAddressId?: number | undefined;
    residentialAddressId?: number | undefined;
    commissionStatementAddressId?: number | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    isLocation?: boolean;
    debtLevelId?: number;
    doNotMarket?: boolean;
    gender?: string | undefined;
    excludeFromTrip?: boolean;
    onlyPobox?: boolean;
    alternateLastName?: string | undefined;
    isEmployee?: boolean | undefined;
    accountingSystemVendorId?: string | undefined;
    isAgency?: boolean;
    marketerClassificationId?: number | undefined;
    vueExportFileDateTime?: Date | undefined;
    isSyncableWithVue?: boolean;
    isHiddenAgentProfile?: boolean;
    profilePicture?: string | undefined;
    federallyFacilitatedMarketplaceUserId?: string | undefined;
    receivePaperStatement?: boolean;
    isIntegrityPlatformPartner?: boolean;
    eoParticipant?: boolean;
    eoParticipantExpirationDate?: Date | undefined;
    w9?: Date | undefined;
    sureLC?: boolean | undefined;
    vested?: boolean;
    parentId?: number | undefined;
    vestedPercentage?: number | undefined;
    uplineId?: number | undefined;
    hierarchyLevelId?: number | undefined;
    taxpayerIdentificationId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    niprStatus?: string | undefined;
    niprDataDiscrepancy?: boolean;
    niprUpdatedDate?: Date | undefined;
    createdByNavigation?: Users;
    hierarchyLevel?: AgentHierarchyLevel;
    profileUpdatedByUser?: Users;
    statusNavigation?: TblStatus;
    user?: Users;
    agentDebt?: AgentDebt[] | undefined;
    agentLead?: AgentLead[] | undefined;
    agentMarketersAgent?: AgentMarketers[] | undefined;
    agentMarketersMarketer?: AgentMarketers[] | undefined;
    agentPortalPassword?: AgentPortalPassword[] | undefined;
    agentPortalPasswordReset?: AgentPortalPasswordReset[] | undefined;
    agentPrincipalAgentsAgent?: AgentPrincipalAgents[] | undefined;
    agentPrincipalAgentsPrincipalAgent?: AgentPrincipalAgents[] | undefined;
    agentProductLine?: AgentProductLine[] | undefined;
    bankAccounts?: BankAccounts[] | undefined;
    licensePrincipalAgents?: LicensePrincipalAgents[] | undefined;
    agentContact?: AgentContact[] | undefined;
    agentNotesAgent?: AgentNotes[] | undefined;
    agentNotesHierarchyPremier?: AgentNotes[] | undefined;
    agentToAddress?: AgentToAddress[] | undefined;
    agentToPayeeAgent?: AgentToPayee[] | undefined;
    agentToPayeePayee?: AgentToPayee[] | undefined;
    appointment?: Appointment[] | undefined;
    certification?: Certification[] | undefined;
    tblDocumentAgent?: TblDocument[] | undefined;
    tblDocumentMarketerAgent?: TblDocument[] | undefined;
    tblDocumentUplineAgent?: TblDocument[] | undefined;
    tblLevelMarketer?: TblLevelMarketer[] | undefined;
    licenseAgent?: License[] | undefined;
    licenseLocation?: LicenseLocation[] | undefined;
    licensePayee?: License[] | undefined;
    policy?: Policy[] | undefined;
    profile?: Profile[] | undefined;
    renewalCommissions?: RenewalCommissions[] | undefined;
    renewalRatesAgent?: RenewalRates[] | undefined;
    renewalRatesPayTo?: RenewalRates[] | undefined;
    userTeam?: UserTeam[] | undefined;
    userTeamAgencyId?: UserTeamAgencyId[] | undefined;
    users?: Users[] | undefined;
    agentAlert?: AgentAlert[] | undefined;
    appUserRoleDownlineAgencies?: AppUserRoleDownlineAgency[] | undefined;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
    taxpayerIdentification?: TaxpayerIdentification;
  }
  
  export interface AgentContact {
    id?: number;
    agentId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    default?: boolean;
    enableSMS?: boolean;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    alternativePointOfContactTypeId?: number | undefined;
    isPhoneUnsubscribed?: boolean | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    contactType?: ContactType;
    phoneType?: PhoneType;
    createdByUser?: Users;
    alternativePointOfContactType?: AlternativePointOfContactType;
    emailType?: EmailType;
  }
  
  export interface LicenseCommunication {
    id?: number;
    createdDate?: Date;
    createdByUserId?: number;
    agentContactId?: number | undefined;
    communicationTypeId?: number;
    licenseId?: number;
    inheratance?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentContact?: AgentContact;
    license?: License;
  }
  
  export interface AgentContactSPModel {
    id?: number;
    agentId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    default?: boolean;
  }
  
  export interface CommunicationLookupResponse {
    communicationTypes?: ListItem[] | undefined;
    contactOptions?: AgentContactSPModel[] | undefined;
  }
  
  export interface CompanyLicenseNumberDefaultsListModel {
    id?: number;
    companyId?: number;
    company?: string | undefined;
    licenseNumberType?: string | undefined;
    isWritableDefault?: boolean;
  }
  
  export interface CompanyLicenseNumberDefaultsSearchResponse {
    recordCount?: number;
    emailAllRecords?: CompanyLicenseNumberDefaultsListModel[] | undefined;
    data?: CompanyLicenseNumberDefaultsListModel[] | undefined;
  }
  
  export interface ContactByIdResponse {
    companyId?: number;
    id?: number;
    contactTypeId?: number;
    contactType?: string | undefined;
    contactValue?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    phoneTypeId?: number;
    notes?: string | undefined;
    emailTypeId?: number;
    alternativePointOfContactTypeId?: number;
    phoneType?: string | undefined;
    emailType?: string | undefined;
    alternativePointOfContactType?: string | undefined;
  }
  
  export interface ContactLookupsModel {
    contactType?: ListItem[] | undefined;
    phoneType?: ListItem[] | undefined;
    emailType?: ListItem[] | undefined;
    alternativePointOfContactType?: ListItem[] | undefined;
  }
  
  export interface ContractRequest {
    pageIndex?: number;
    pageSize?: number;
    readonly skip?: number;
    readonly take?: number;
    sortColumn?: string | undefined;
    sortAscending?: boolean;
    fullTextFilter?: string | undefined;
    agentId?: number | undefined;
    policyStatusId?: number | undefined;
    searchParameter?: string | undefined;
    marketerId?: number | undefined;
    divisionId?: number | undefined;
    isDownloadCall?: boolean;
    carrierIds?: number[] | undefined;
    isIncludeInactiveCarrier?: boolean;
  }
  
  export interface UplineInfo {
    agentId?: number;
    name?: string | undefined;
    contractId?: number;
  }
  
  export interface ContractListModel {
    id?: number;
    status?: string | undefined;
    payee?: string | undefined;
    statusReason?: string | undefined;
    carrier?: string | undefined;
    startDate?: Date;
    displayStartDate?: Date;
    endDate?: Date | undefined;
    displayEndDate?: Date | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    doNotContact?: boolean;
    underConstruction?: boolean | undefined;
    licenseNumber?: string[] | undefined;
    statusId?: number;
    statusReasonId?: number;
    salesTypeId?: number;
    salesTypeName?: string | undefined;
    isTeleSale?: boolean;
    replacedFromLicenseId?: number | undefined;
    replacedByLicenseId?: number | undefined;
    advanceMonths?: string | undefined;
    submittedDate?: Date | undefined;
    receiptDate?: Date | undefined;
    approvalDate?: Date | undefined;
    firstApplicationDate?: Date | undefined;
    toh?: string | undefined;
    integrityLegalEntity?: string | undefined;
    uplines?: UplineInfo[] | undefined;
    marketerList?: string[] | undefined;
    products?: string[] | undefined;
    productCategories?: string[] | undefined;
    productSubCategories?: string[] | undefined;
    levels?: string[] | undefined;
    processedBy?: string | undefined;
    agentGroup?: string | undefined;
  }
  
  export interface AgentDebtLevel {
    id?: number;
    debtLevelName?: string | undefined;
    description?: string | undefined;
  }
  
  export interface ContractResponse {
    recordCount?: number;
    emailAllRecords?: ContractListModel[] | undefined;
    data?: ContractListModel[] | undefined;
    agentDebtId?: number;
    showWarning?: boolean;
    agentDebtLevelDetail?: AgentDebtLevel;
  }
  
  export interface WritingNumbers {
    writingNumberId?: number;
    number?: string | undefined;
    isWritable?: boolean;
    licenseNumberTypeId?: number;
    licenseNumberTypeName?: string | undefined;
  }
  
  export interface AgentPayeeAgentListView {
    id?: number;
    payeeAgentId?: number;
    payeeAgentFullName?: string | undefined;
    isPayeeHold?: boolean;
  }
  
  export interface WritingNumberTypeResponse {
    id?: number;
    licenseNumberType?: string | undefined;
    isWritableDefault?: boolean;
  }
  
  export interface PrinicpalAgents {
    id?: number;
    principalAgentId?: number;
    principalAgentName?: string | undefined;
    lastName?: string | undefined;
  }
  
  export interface Notes {
    id?: number;
    note?: string | undefined;
    contractingSentNote?: boolean;
    createdDate?: Date;
    createdUser?: string | undefined;
  }
  
  export interface LicenseLocations {
    id?: number;
    locationId?: number;
    agentName?: string | undefined;
    dba?: string | undefined;
    lastName?: string | undefined;
  }
  
  export interface ContractModel {
    id?: number;
    activeLicenseCount?: number;
    agent?: string | undefined;
    npn?: string | undefined;
    isAgency?: boolean;
    enteredDate?: Date;
    startDate?: Date;
    endDate?: Date | undefined;
    submittedDate?: Date | undefined;
    companyId?: number;
    companyName?: string | undefined;
    payeeId?: number;
    saleTypeId?: number;
    advancedMonths?: number;
    statusId?: number;
    statusReasonId?: number;
    agnecyIsPayee?: boolean;
    writingNumbers?: WritingNumbers[] | undefined;
    reportsToId?: number;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarketDownlineDefault?: boolean;
    reportsToLicenseId?: number | undefined;
    uplineAgentId?: number;
    uplineAgentName?: string | undefined;
    term?: string | undefined;
    termStartDate?: Date | undefined;
    termEndDate?: Date | undefined;
    licenseAdvancedId?: number;
    processedBy?: number | undefined;
    processedByName?: string | undefined;
    replacedFromLicenseId?: number | undefined;
    replacedByLicenseId?: number | undefined;
    contractReceiptDate?: Date | undefined;
    approvalDate?: Date | undefined;
    appSubmittedWithin90Days?: Date | undefined;
    appointmentType?: number | undefined;
    agentGroupId?: number | undefined;
    onlyShowActiveAndPending?: boolean | undefined;
    companyList?: ListItem[] | undefined;
    payeeList?: AgentPayeeAgentListView[] | undefined;
    statusReasonList?: ListItem[] | undefined;
    reportsToList?: ListItem[] | undefined;
    licenseStatus?: ListItem[] | undefined;
    licenseNumberTypes?: WritingNumberTypeResponse[] | undefined;
    licenseAdvanceOptions?: ListItem[] | undefined;
    licenseAppointmentType?: ListItem[] | undefined;
    salesTypeList?: ListItem[] | undefined;
    agentGroups?: ListItem[] | undefined;
    principalAgentsList?: ListItem[] | undefined;
    locationsList?: ListItem[] | undefined;
    licenseAdvanceMonths?: ListItem[] | undefined;
    paymentPlanCount?: number;
    downlinesCount?: number;
    agentStatusId?: number | undefined;
    principalAgents?: PrinicpalAgents[] | undefined;
    notes?: Notes[] | undefined;
    locations?: LicenseLocations[] | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdBy?: string | undefined;
  }
  
  export interface ContractViewModel {
    id?: number;
    agent?: string | undefined;
    agentId?: number;
    npn?: string | undefined;
    isAgency?: boolean;
    enteredDate?: Date;
    startDate?: Date;
    endDate?: Date | undefined;
    submittedDate?: Date | undefined;
    companyId?: number;
    company?: string | undefined;
    payeeName?: string | undefined;
    saleType?: string | undefined;
    advancedMonths?: string | undefined;
    status?: string | undefined;
    statusReason?: string | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarketDownlineDefault?: boolean;
    term?: string | undefined;
    termStartDate?: Date | undefined;
    termEndDate?: Date | undefined;
    licenseAdvancedId?: number;
    processedByName?: string | undefined;
    contractReceiptDate?: Date | undefined;
    approvalDate?: Date | undefined;
    appSubmittedWithin90Days?: Date | undefined;
    appointmentType?: string | undefined;
    agentGroupName?: string | undefined;
    reportsToLicenseId?: number | undefined;
    payeeAgentId?: number | undefined;
    isShowProductNames?: boolean;
    includeTerminatedDownlines?: boolean;
    replacedFromLicenseId?: number | undefined;
    replacedByLicenseId?: number | undefined;
    isPayeeHold?: boolean;
    prinicpalAgents?: PrinicpalAgents[] | undefined;
    notes?: Notes[] | undefined;
    locations?: LicenseLocations[] | undefined;
    writingNumbers?: WritingNumbers[] | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdBy?: string | undefined;
  }
  
  export interface DeleteResponse {
    isDeleted?: boolean;
    message?: string | undefined;
  }
  
  export interface ProductDetailsModel {
    levelId?: number;
    payoutLevelId?: number;
    marketerId?: number;
    existingMarketerId?: number;
    productId?: number;
    specialInstructions?: string | undefined;
    sortOrder?: number;
  }
  
  export interface CustAttrToEntityModel {
    customAttributeScreenId?: number;
    entityId?: number;
    value?: string | undefined;
  }
  
  export interface CreateUpdateContractModel {
    id?: number;
    agentId?: number;
    companyId?: number;
    statusId?: number;
    statusReasonId?: number | undefined;
    apptDate?: Date;
    termDate?: Date | undefined;
    submittedDate?: Date | undefined;
    payeeId?: number;
    advancedMonths?: number;
    agencyIsPayee?: boolean;
    reportsToLicenseId?: number | undefined;
    writingNumbers?: WritingNumbers[] | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarketDownlineDefault?: boolean;
    maxAdvanceAmount?: number;
    salesTypeId?: number;
    isUpdateDownlineDNx?: boolean;
    processedBy?: number | undefined;
    contractReceiptDate?: Date | undefined;
    approvalDate?: Date | undefined;
    appSubmittedWithin90Days?: Date | undefined;
    appointmentType?: number | undefined;
    agentGroupId?: number | undefined;
    onlyShowActiveAndPending?: boolean | undefined;
    isEmailNotificationSend?: boolean;
    agentStatusId?: number;
    prinicpalAgents?: PrinicpalAgents[] | undefined;
    notes?: Notes[] | undefined;
    locations?: LicenseLocations[] | undefined;
    productDetails?: ProductDetailsModel[] | undefined;
    customAttributes?: CustAttrToEntityModel[] | undefined;
  }
  
  export interface ContactOptionsResponse {
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
  }
  
  export interface StatusReasonResponse {
    statusReasonId?: number;
    statusReason?: string | undefined;
  }
  
  export interface ImmediateUplineResponse {
    licenseId?: number | undefined;
    term?: string | undefined;
    agentId?: number;
    agentName?: string | undefined;
    agentWritingNumber?: string | undefined;
    writingNumberType?: string | undefined;
    status?: string | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarketDownlineDefault?: boolean;
  }
  
  export interface ContractAssocaitionsResponse {
    message?: string | undefined;
  }
  
  export interface ProductModel {
    text?: string | undefined;
    value?: string | undefined;
    subCategoryId?: number;
    hidden?: boolean;
  }
  
  export interface SubCategoryModel {
    text?: string | undefined;
    value?: string | undefined;
    categoryId?: number;
  }
  
  export interface ProductDetailsLookupResponse {
    payoutLevels?: ListItem[] | undefined;
    paidCommission?: number;
    contractingSentNote?: Notes;
    products?: ProductModel[] | undefined;
    category?: ListItem[] | undefined;
    subCategory?: SubCategoryModel[] | undefined;
  }
  
  export interface ContractUplineDetailResponse {
    uplineId?: number | undefined;
    uplineName?: string | undefined;
  }
  
  export interface ContractGridColumnRequest {
    gridColumnOrder?: string | undefined;
  }
  
  export interface DownloadFileModel {
    data?: string | undefined;
    message?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
  }
  
  export interface BulkUpdateContractsQueue {
    batchId?: number;
    module?: string | undefined;
    fileName?: string | undefined;
    totalRecords?: number;
    processedRecords?: number;
    failedRecords?: number;
    status?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
  }
  
  export interface BulkUpdateContractsQueueResponse {
    recordCount?: number;
    emailAllRecords?: BulkUpdateContractsQueue[] | undefined;
    data?: BulkUpdateContractsQueue[] | undefined;
  }
  
  export interface BulkUpdateContractsHistory {
    id?: number;
    agentId?: number;
    action?: string | undefined;
    contractId?: number;
    carrierName?: string | undefined;
    agentOrAgencyName?: string | undefined;
    status?: string | undefined;
    comments?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
  }
  
  export interface BulkUpdateContractsHistoryResponse {
    recordCount?: number;
    emailAllRecords?: BulkUpdateContractsHistory[] | undefined;
    data?: BulkUpdateContractsHistory[] | undefined;
  }
  
  export interface ProductDetailsModel2 {
    levelId?: number;
    payoutLevelId?: number;
    marketerId?: number;
    existingMarketerId?: number;
    productId?: number;
    specialInstructions?: string | undefined;
    sortOrder?: number;
  }
  
  export interface RTSUpdateContractRequestModel {
    id?: number;
    agentId?: number;
    companyId?: number;
    statusId?: number;
    statusReasonId?: number | undefined;
    apptDate?: Date;
    termDate?: Date | undefined;
    reportsToLicenseId?: number | undefined;
    writingNumbers?: WritingNumbers[] | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarketDownlineDefault?: boolean;
    agentStatusId?: number;
    isUpdateDownlineDNx?: boolean;
    isDetailLoaded?: boolean;
    isEmailNotificationSend?: boolean;
    productDetails?: ProductDetailsModel2[] | undefined;
  }
  
  export interface GetContractManagementRequest {
    pageIndex?: number;
    pageSize?: number;
    readonly skip?: number;
    readonly take?: number;
    sortColumn?: string | undefined;
    sortAscending?: boolean;
    fullTextFilter?: string | undefined;
    searchParameter?: string | undefined;
    includeMetricsDetails?: boolean;
  }
  
  export interface GetContractManagementModel {
    dateCreated?: Date;
    contractId?: number;
    carrierName?: string | undefined;
    agentNPN?: string | undefined;
    agentName?: string | undefined;
    agentId?: number;
    writingNumber?: string | undefined;
    immediateUpline?: string | undefined;
    contractStatus?: string | undefined;
    pdfIconLink?: string | undefined;
  }
  
  export interface GetContractManagementResponse {
    recordCount?: number;
    emailAllRecords?: GetContractManagementModel[] | undefined;
    data?: GetContractManagementModel[] | undefined;
  }
  
  export interface ContractManagementMetricsResponse {
    allCount?: number;
    pendingCount?: number;
    inReviewCount?: number;
    submittedCount?: number;
    activeCount?: number;
  }
  
  export interface ContractManagementResponse {
    contractDetails?: GetContractManagementResponse;
    contractMetrics?: ContractManagementMetricsResponse;
  }
  
  export interface SendContractInviteRequest {
    agentID?: number;
    carrierId?: number;
    carrierName?: string | undefined;
  }
  
  export interface SubmissionLicenseRequest {
    contractId?: number;
    userId?: string | undefined;
    contractStatus?: string | undefined;
  }
  
  export interface SendAgentInviteRequest {
    agentName?: string | undefined;
    agentEmail?: string | undefined;
  }
  
  export interface DownloadFileModel2 {
    data?: string | undefined;
    message?: string | undefined;
    fileName?: string | undefined;
  }
  
  export interface ProductIdList {
    levelId?: number;
    productId?: number;
    subCategoryId?: number;
    profileAssociation?: boolean;
    hidden?: boolean;
  }
  
  export interface LevelListModel {
    levelId?: number;
    profileAssociation?: boolean;
    productId?: number;
    productIds?: ProductIdList[] | undefined;
    productName?: string | undefined;
    categoryName?: string | undefined;
    categoryId?: number;
    profileId?: number;
    categoryIds?: number[] | undefined;
    subCategoryName?: string | undefined;
    subCategoryId?: number;
    subCategoryIds?: number[] | undefined;
    specialInstructions?: string | undefined;
    sortOrder?: number | undefined;
    commissions?: number;
    payoutLevelId?: number;
    description?: string | undefined;
    documentId?: number;
    marketer?: string | undefined;
    marketerId?: number;
    hidden?: boolean;
  }
  
  export interface LevelResponse {
    recordCount?: number;
    emailAllRecords?: LevelListModel[] | undefined;
    data?: LevelListModel[] | undefined;
  }
  
  export interface MarketerDataList {
    marketerId?: number;
    marketerName?: string | undefined;
    marketerSplit?: number;
  }
  
  export interface LevelDetailModel {
    levelId?: number;
    productId?: number;
    productSubCategoryId?: number;
    productName?: string | undefined;
    specialInstructions?: string | undefined;
    commissions?: number | undefined;
    payoutLevelId?: number | undefined;
    description?: string | undefined;
    marketerId?: number;
    marketer?: string | undefined;
    marketerList?: MarketerDataList[] | undefined;
    dateCreated?: string | undefined;
    createdBy?: string | undefined;
    contractingSentFor?: string | undefined;
    payoutLevel?: string | undefined;
  }
  
  export interface LevelMarkterDetailModel {
    levelMarkterId?: number;
    split?: number;
  }
  
  export interface CreateUpdateLevelRequest {
    id?: number;
    contractId?: number;
    payoutLevelId?: number;
    levelMarkterDetailModelList?: LevelMarkterDetailModel[] | undefined;
    paidCommission?: number;
    productId?: number;
    specialInstructions?: string | undefined;
  }
  
  export interface DeleteResponse2 {
    isDeleted?: boolean;
    message?: string | undefined;
  }
  
  export interface ProductLevel {
    text?: string | undefined;
    value?: string | undefined;
    subCategoryId?: number;
  }
  
  export interface LastestContractingSentNoteView {
    note?: string | undefined;
    createdByUser?: string | undefined;
    dateTime?: Date;
  }
  
  export interface LevelsLookupResponse {
    payoutLevels?: ListItem[] | undefined;
    paidCommission?: number;
    products?: ProductLevel[] | undefined;
    note?: LastestContractingSentNoteView;
  }
  
  export interface CommissionModel {
    commissions?: number;
    productName?: string | undefined;
    hidden?: boolean;
  }
  
  export interface ProductPaidCommissionResponse {
    data?: CommissionModel[] | undefined;
  }
  
  export interface LastestContractingSentNoteView2 {
    dateTime?: Date;
    note?: string | undefined;
    createdByUserFirstName?: string | undefined;
    createdByUserLastName?: string | undefined;
    readonly createdByUserFullName?: string | undefined;
  }
  
  export interface LevelNoteResponse {
    lastestContractingSentNoteView?: LastestContractingSentNoteView2;
  }
  
  export interface DeleteRequest {
    levelIds?: number[] | undefined;
  }
  
  export interface DeleteProductsByLevelResponse {
    isDeleted?: boolean;
    message?: string | undefined;
  }
  
  export interface InconsistencyContractsRequest {
    carrierIds?: string[] | undefined;
    agentId?: number;
    npn?: string | undefined;
  }
  
  export interface ListItemSelect {
    value?: string | undefined;
    label?: string | undefined;
    selected?: boolean;
  }
  
  export interface StatusReasonModel {
    label?: string | undefined;
    value?: string | undefined;
    statusId?: number;
  }
  
  export interface ContractModel2 {
    contractId?: number;
    npn?: string | undefined;
    agentId?: number;
    statusId?: number;
    status?: string | undefined;
    statusReasonId?: number;
    statusReason?: string | undefined;
    contractStartDate?: string | undefined;
    contractEndDate?: string | undefined;
    immediateUplineId?: number | undefined;
    immediateUplineName?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    awNs?: string | undefined;
    productCount?: number;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarketDownlineDefault?: boolean;
    downlineLicensesCount?: number;
    activeLicenseCount?: number;
  }
  
  export interface InconsistencyContractsResponse {
    statusList?: ListItemSelect[] | undefined;
    statusReasonList?: StatusReasonModel[] | undefined;
    contracts?: ContractModel2[] | undefined;
  }
  
  export interface InconsistencyAgentsRequest {
    pageIndex?: number;
    pageSize?: number;
    readonly skip?: number;
    readonly take?: number;
    sortColumn?: string | undefined;
    sortAscending?: boolean;
    fullTextFilter?: string | undefined;
    carrierIds?: string[] | undefined;
    agentIds?: number[] | undefined;
  }
  
  export interface InconsistencyAgentModel {
    carrierId?: number;
    npn?: string | undefined;
    agentId?: number;
    name?: string | undefined;
  }
  
  export interface InconsistencyAgentsResponse {
    recordCount?: number;
    emailAllRecords?: InconsistencyAgentModel[] | undefined;
    data?: InconsistencyAgentModel[] | undefined;
  }
  
  export interface LookupsForInconsistencyContractRequest {
    carrierId?: number;
    contractId?: number;
  }
  
  export interface SubCategoryRtsModel {
    label?: string | undefined;
    value?: string | undefined;
    categoryId?: number;
  }
  
  export interface ProductRtsModel {
    label?: string | undefined;
    value?: string | undefined;
    subCategoryId?: number;
    hidden?: boolean;
  }
  
  export interface LookupsForInconsistencyContractResponse {
    category?: ListItemSelect[] | undefined;
    subCategory?: SubCategoryRtsModel[] | undefined;
    productList?: ProductRtsModel[] | undefined;
    levelList?: ListItemSelect[] | undefined;
    marketerList?: ListItemSelect[] | undefined;
    writingNumberTypeList?: ListItemSelect[] | undefined;
    writingNumbers?: WritingNumbers[] | undefined;
    products?: LevelListModel[] | undefined;
  }
  
  export interface LatestLicensePersistencyModel {
    licensePersistencyId?: number;
    licensePersistencyTypeName?: string | undefined;
    licensePersistencyTypeId?: number;
    createdDateTime?: Date;
    persistencyPercentage?: number;
    hexColor?: string | undefined;
  }
  
  export interface LatestLicensePersistencyResponse {
    recordCount?: number;
    emailAllRecords?: LatestLicensePersistencyModel[] | undefined;
    data?: LatestLicensePersistencyModel[] | undefined;
  }
  
  export interface LicensePersistencyModel {
    licensePersistencyId?: number;
    licenseId?: number;
    licensePersistencyTypeName?: string | undefined;
    licensePersistencyTypeId?: number;
    createdDateTime?: Date;
    persistencyPercentage?: number;
    hexColor?: string | undefined;
  }
  
  export interface AllColoringRulesModel {
    id?: number;
    companyId?: number;
    company?: string | undefined;
    licensePersistencyTypeName?: string | undefined;
    color?: string | undefined;
    startRange?: number;
    stopRange?: number;
  }
  
  export interface AllColoringRulesResponse {
    recordCount?: number;
    emailAllRecords?: AllColoringRulesModel[] | undefined;
    data?: AllColoringRulesModel[] | undefined;
  }
  
  export interface ColoringRuleModel {
    licensePersistencyTypeColoringRuleId?: number;
    licensePersistencyTypeId?: number;
    hexColor?: string | undefined;
    startRange?: number;
    stopRange?: number;
  }
  
  export interface LicensePersistencyTypeResponseModel {
    id?: number;
    companyId?: number;
    licensePersistencyTypeName?: string | undefined;
    sortOrder?: number;
  }
  
  export interface LicensePersistencyTypeResponse {
    recordCount?: number;
    emailAllRecords?: LicensePersistencyTypeResponseModel[] | undefined;
    data?: LicensePersistencyTypeResponseModel[] | undefined;
  }
  
  export interface LicensePersistencyTypeModel {
    licensePersistencyTypeId?: number;
    companyId?: number;
    sortOrder?: number;
    licensePersistencyTypeName?: string | undefined;
  }
  
  export interface SaveSplittLicenseRequest {
    fromLicenseID?: number;
    toLicenseID?: number | undefined;
    toAgentID?: number;
    operationCommand?: number;
  }
  
  export interface LicenseSplitterResponse {
    agentId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    errorMessage?: string | undefined;
    succeded?: boolean;
  }
  
  export interface BuildAllCommandRequest {
    companyId?: number;
    productSubCategoryId?: number;
  }
  
  export interface AgentModel {
    agentID?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAgency?: boolean;
  }
  
  export interface LicenseStateListModel {
    id?: number;
    licenseId?: number;
    stateId?: number;
    state?: string | undefined;
    apptDate?: Date | undefined;
    termDate?: Date | undefined;
  }
  
  export interface LicenseStateSearchResponse {
    recordCount?: number;
    emailAllRecords?: LicenseStateListModel[] | undefined;
    data?: LicenseStateListModel[] | undefined;
  }
  
  export interface LicenseStateModel {
    id?: number;
    licenseId?: number;
    stateId?: number;
    stateIds?: number[] | undefined;
    issueDate?: Date | undefined;
    expirationDate?: Date | undefined;
  }
  
  export interface LicenseStatusReasonsListModel {
    id?: number;
    reason?: string | undefined;
    statusId?: number;
    licenseStatus?: string | undefined;
    licenseCount?: number;
  }
  
  export interface LicenseStatusReasonsSearchResponse {
    recordCount?: number;
    emailAllRecords?: LicenseStatusReasonsListModel[] | undefined;
    data?: LicenseStatusReasonsListModel[] | undefined;
  }
  
  export interface LicenseStatusReasonModel {
    id?: number;
    reason?: string | undefined;
    statusId?: number;
    licenseStatus?: string | undefined;
    licenseCount?: number;
  }
  
  export interface LocationDetailModel {
    id?: number;
    agentName?: string | undefined;
    dba?: string | undefined;
  }
  
  export interface LocationResponse {
    recordCount?: number;
    emailAllRecords?: LocationDetailModel[] | undefined;
    data?: LocationDetailModel[] | undefined;
  }
  
  export interface LocationCreateRequest {
    contractId?: number;
    locationId?: number;
  }
  
  export interface LocationDBAResponse {
    agentId?: number;
    dba?: string | undefined;
  }
  
  export interface RtsDataModel {
    id?: number;
    npn?: string | undefined;
    carrierGroup?: string | undefined;
    awn?: string | undefined;
    state?: string | undefined;
    product?: string | undefined;
    rtsStatus?: string | undefined;
    planYear?: number;
    selfAttestationDate?: Date | undefined;
    isSelfAttested?: boolean;
  }
  
  export interface RtsCertificationModel {
    id?: number;
    npn?: string | undefined;
    carrierGroup?: string | undefined;
    awn?: string | undefined;
    state?: string | undefined;
    product?: string | undefined;
    productType?: string | undefined;
    rtsStatus?: string | undefined;
    planYear?: number;
    selfAttestationDate?: Date | undefined;
    isSelfAttested?: boolean;
  }
  
  export interface ProductsByCarrierResponse {
    productList?: ListItemSelect[] | undefined;
    writingNumberList?: ListItemSelect[] | undefined;
  }
  
  export interface TokenResponse {
    access_token?: string | undefined;
    url?: string | undefined;
    finalExpensesUrl?: string | undefined;
  }
  
  export interface ActiveCarrierList {
    carrierName?: string | undefined;
    writingNumbers?: string[] | undefined;
    productTypes?: string[] | undefined;
  }
  
  export interface ActiveCarrierResponse {
    lifeCarrierList?: ActiveCarrierList[] | undefined;
    healthCarrierList?: ActiveCarrierList[] | undefined;
  }
  
  export interface MarketerMailConfigsListModel {
    id?: number;
    marketerName?: string | undefined;
    agentId?: number;
    isMailEnabled?: boolean;
  }
  
  export interface MarketerMailConfigsSearchResponse {
    recordCount?: number;
    emailAllRecords?: MarketerMailConfigsListModel[] | undefined;
    data?: MarketerMailConfigsListModel[] | undefined;
  }
  
  export interface MarketerMailConfigModel {
    id?: number;
    marketerAgentId?: number;
    isEmailEnabled?: boolean;
  }
  
  export enum FileType2 {
    _0 = 0,
    _1 = 1,
  }
  
  export interface ContractInviteRequest {
    agentId?: number;
    uplineAgentId?: number;
    marketerIds?: number[] | undefined;
    companyId?: number;
    startDate?: Date;
    stopDate?: Date;
    fileType?: FileType2;
  }
  
  export interface ContractingSentRequest {
    companyId?: number;
    startDate?: Date;
    stopDate?: Date;
    teamId?: number;
    marketerIds?: number[] | undefined;
    fileType?: FileType2;
  }
  
  export interface ContractingSentNoFUPIn30DaysRequest {
    startDate?: Date;
    stopDate?: Date;
    teamId?: number;
    fileType?: FileType2;
  }
  
  export interface DownlineAgentsRequest {
    uplineId?: number;
    companyId?: number;
    fileType?: FileType2;
  }
  
  export interface ContractsByMarketerRequest {
    companyId?: number;
    startDate?: Date;
    stopDate?: Date;
    licenseStates?: number[] | undefined;
    homeStates?: string[] | undefined;
    marketerIds?: number[] | undefined;
    fileType?: FileType2;
  }
  
  export interface ContractsWithNoBusinessRequest {
    startDate?: Date;
    stopDate?: Date;
    companyId?: number;
    licenseStates?: number[] | undefined;
    marketerIds?: number[] | undefined;
    uplineId?: number;
    fileType?: FileType2;
  }
  
  export interface CarrierUpdatesRequest {
    companyId?: number;
    licenseStates?: number[] | undefined;
    fileType?: FileType2;
  }
  
  export interface FaxConfirmationRequest {
    startDate?: Date;
    stopDate?: Date;
    companyId?: number;
    fileType?: FileType2;
  }
  
  export interface LicenseCountByCompanyRequest {
    startDate?: Date;
    stopDate?: Date;
    marketerIds?: number[] | undefined;
    fileType?: FileType2;
  }
  
  export interface OrdersByDivisionRequest {
    startDate?: Date;
    stopDate?: Date;
    divisionId?: number;
    fileType?: FileType2;
  }
  
  export interface ContractDetailsRequest {
    agentId?: number;
    companyGroupId?: number;
    companyId?: number;
    licenseStatusId?: number;
    startDate?: Date;
    stopDate?: Date;
    subCategories?: number[] | undefined;
    products?: number[] | undefined;
    marketerIds?: number[] | undefined;
    licenseStates?: number[] | undefined;
    uplineId?: number;
    fileType?: FileType2;
  }
  
  export interface AgentHierarchy {
    agentId?: number;
    isAgency?: boolean;
    agentName?: string | undefined;
    children?: AgentHierarchy[] | undefined;
    payoutLevelDescription?: string | undefined;
    licenseId?: number;
    agentNumber?: string | undefined;
    agentStatus?: string | undefined;
    underConstruction?: boolean;
    licenseStatusName?: string | undefined;
    isDeleted?: boolean;
    payee?: string | undefined;
  }
  
  export interface SummaryResponse {
    agentHierarchy?: AgentHierarchy;
  }
  
  export interface FileParameter {
    data: any;
    fileName: string;
  }
  
  export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;
  
    constructor(
      message: string,
      status: number,
      response: string,
      headers: { [key: string]: any },
      result: any
    ) {
      super();
  
      this.message = message;
      this.status = status;
      this.response = response;
      this.headers = headers;
      this.result = result;
    }
  
    protected isApiException = true;
  
    static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true;
    }
  }
  
  function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
  ): any {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
  }
  